// Enhanced calculation formulas with validation for ManuCalc tools
import {
  MATERIAL_DATABASE,
  TOOL_COATINGS,
  TOOL_MATERIAL_MULTIPLIERS,
} from "../data/machiningMaterials";

export { MATERIAL_DATABASE, TOOL_COATINGS, TOOL_MATERIAL_MULTIPLIERS };

export const validateInputs = (params, requiredFields) => {
  const errors = {};
  requiredFields.forEach((field) => {
    if (params[field] === "" || params[field] === null || params[field] === undefined) {
      errors[field] = "More data required";
    }
  });
  return errors;
};
//////////////////////////////////////////////////
// GEAR RATIO + GEAR CUTTING (NEW)
//////////////////////////////////////////////////

export const calculateGearRatio = (params) => {
  const errors = validateInputs(params, [
    "driverTeeth",
    "drivenTeeth",
  ]);

  if (Object.keys(errors).length > 0) {
    return { errors, confidence: "Invalid" };
  }

  const { driverTeeth, drivenTeeth } = params;

  if (driverTeeth <= 0) errors.driverTeeth = "Driver teeth must be positive";
  if (drivenTeeth <= 0) errors.drivenTeeth = "Driven teeth must be positive";

  if (Object.keys(errors).length > 0) {
    return { errors, confidence: "Invalid" };
  }

  const ratio = drivenTeeth / driverTeeth;

  return {
    ratio: Number(ratio.toFixed(4)),
    ratioText: `${drivenTeeth}:${driverTeeth}`,
    warnings: [],
    confidence: "High",
  };
};

export const calculateGearCutting = (params) => {
  const errors = validateInputs(params, [
    "teeth",
    "diametralPitch",
  ]);

  if (Object.keys(errors).length > 0) {
    return { errors, confidence: "Invalid" };
  }

  const { teeth, diametralPitch } = params;

  if (teeth <= 0) errors.teeth = "Tooth count must be positive";
  if (diametralPitch <= 0) errors.diametralPitch = "Diametral pitch must be positive";

  if (Object.keys(errors).length > 0) {
    return { errors, confidence: "Invalid" };
  }

  const pitchDiameter = teeth / diametralPitch;
  const circularPitch = Math.PI / diametralPitch;
  const addendum = 1 / diametralPitch;
  const dedendum = 1.25 / diametralPitch;
  const wholeDepth = addendum + dedendum;
  const outsideDiameter = (teeth + 2) / diametralPitch;
  const rootDiameter = pitchDiameter - 2 * dedendum;

  const warnings = [];

  if (teeth < 12) {
    warnings.push("Low tooth count may require profile shift to avoid undercutting.");
  }

  return {
    pitchDiameter: Number(pitchDiameter.toFixed(4)),
    outsideDiameter: Number(outsideDiameter.toFixed(4)),
    rootDiameter: Number(rootDiameter.toFixed(4)),
    circularPitch: Number(circularPitch.toFixed(4)),
    addendum: Number(addendum.toFixed(4)),
    dedendum: Number(dedendum.toFixed(4)),
    wholeDepth: Number(wholeDepth.toFixed(4)),
    warnings,
    confidence: warnings.length === 0 ? "High" : "Medium",
  };
};

//////////////////////////////////////////////////
// DRILL SIZE DATABASE
//////////////////////////////////////////////////

export const DRILL_SIZES = [
  { name: "#80", size: 0.0135 },
  { name: "#79", size: 0.0145 },
  { name: "#78", size: 0.016 },
  { name: "#77", size: 0.018 },
  { name: "#76", size: 0.02 },
  { name: "#75", size: 0.021 },
  { name: "#74", size: 0.0225 },
  { name: "#73", size: 0.024 },
  { name: "#72", size: 0.025 },
  { name: "#71", size: 0.026 },
  { name: "#70", size: 0.028 },
  { name: "#69", size: 0.0292 },
  { name: "#68", size: 0.031 },
  { name: "#67", size: 0.032 },
  { name: "#66", size: 0.033 },
  { name: "#65", size: 0.035 },
  { name: "#64", size: 0.036 },
  { name: "#63", size: 0.037 },
  { name: "#62", size: 0.038 },
  { name: "#61", size: 0.039 },
  { name: "#60", size: 0.04 },
  { name: "#59", size: 0.041 },
  { name: "#58", size: 0.042 },
  { name: "#57", size: 0.043 },
  { name: "#56", size: 0.0465 },
  { name: "#55", size: 0.052 },
  { name: "#54", size: 0.055 },
  { name: "#53", size: 0.0595 },
  { name: "#52", size: 0.0635 },
  { name: "#51", size: 0.067 },
  { name: "#50", size: 0.07 },
  { name: "#49", size: 0.073 },
  { name: "#48", size: 0.076 },
  { name: "#47", size: 0.0785 },
  { name: "#46", size: 0.081 },
  { name: "#45", size: 0.082 },
  { name: "#44", size: 0.086 },
  { name: "#43", size: 0.089 },
  { name: "#42", size: 0.0935 },
  { name: "#41", size: 0.096 },
  { name: "#40", size: 0.098 },
  { name: "#39", size: 0.0995 },
  { name: "#38", size: 0.1015 },
  { name: "#37", size: 0.104 },
  { name: "#36", size: 0.1065 },
  { name: "#35", size: 0.11 },
  { name: "#34", size: 0.111 },
  { name: "#33", size: 0.113 },
  { name: "#32", size: 0.116 },
  { name: "#31", size: 0.12 },
  { name: "#30", size: 0.1285 },
  { name: "#29", size: 0.136 },
  { name: "#28", size: 0.1405 },
  { name: "#27", size: 0.144 },
  { name: "#26", size: 0.147 },
  { name: "#25", size: 0.1495 },
  { name: "#24", size: 0.152 },
  { name: "#23", size: 0.154 },
  { name: "#22", size: 0.157 },
  { name: "#21", size: 0.159 },
  { name: "#20", size: 0.161 },
  { name: "#19", size: 0.166 },
  { name: "#18", size: 0.1695 },
  { name: "#17", size: 0.173 },
  { name: "#16", size: 0.177 },
  { name: "#15", size: 0.18 },
  { name: "#14", size: 0.182 },
  { name: "#13", size: 0.185 },
  { name: "#12", size: 0.189 },
  { name: "#11", size: 0.191 },
  { name: "#10", size: 0.1935 },
  { name: "#9", size: 0.196 },
  { name: "#8", size: 0.199 },
  { name: "#7", size: 0.201 },
  { name: "#6", size: 0.204 },
  { name: "#5", size: 0.2055 },
  { name: "#4", size: 0.209 },
  { name: "#3", size: 0.213 },
  { name: "#2", size: 0.221 },
  { name: "#1", size: 0.228 },

  { name: "A", size: 0.234 },
  { name: "B", size: 0.238 },
  { name: "C", size: 0.242 },
  { name: "D", size: 0.246 },
  { name: "E", size: 0.25 },
  { name: "F", size: 0.257 },
  { name: "G", size: 0.261 },
  { name: "H", size: 0.266 },
  { name: "I", size: 0.272 },
  { name: "J", size: 0.277 },
  { name: "K", size: 0.281 },
  { name: "L", size: 0.29 },
  { name: "M", size: 0.295 },
  { name: "N", size: 0.302 },
  { name: "O", size: 0.316 },
  { name: "P", size: 0.323 },
  { name: "Q", size: 0.332 },
  { name: "R", size: 0.339 },
  { name: "S", size: 0.348 },
  { name: "T", size: 0.358 },
  { name: "U", size: 0.368 },
  { name: "V", size: 0.377 },
  { name: "W", size: 0.386 },
  { name: "X", size: 0.397 },
  { name: "Y", size: 0.404 },
  { name: "Z", size: 0.413 },

  { name: "1/64", size: 0.015625 },
  { name: "1/32", size: 0.03125 },
  { name: "3/64", size: 0.046875 },
  { name: "1/16", size: 0.0625 },
  { name: "5/64", size: 0.078125 },
  { name: "3/32", size: 0.09375 },
  { name: "7/64", size: 0.109375 },
  { name: "1/8", size: 0.125 },
  { name: "9/64", size: 0.140625 },
  { name: "5/32", size: 0.15625 },
  { name: "11/64", size: 0.171875 },
  { name: "3/16", size: 0.1875 },
  { name: "13/64", size: 0.203125 },
  { name: "7/32", size: 0.21875 },
  { name: "15/64", size: 0.234375 },
  { name: "1/4", size: 0.25 },
  { name: "17/64", size: 0.265625 },
  { name: "9/32", size: 0.28125 },
  { name: "19/64", size: 0.296875 },
  { name: "5/16", size: 0.3125 },
  { name: "21/64", size: 0.328125 },
  { name: "11/32", size: 0.34375 },
  { name: "23/64", size: 0.359375 },
  { name: "3/8", size: 0.375 },
  { name: "25/64", size: 0.390625 },
  { name: "13/32", size: 0.40625 },
  { name: "27/64", size: 0.421875 },
  { name: "7/16", size: 0.4375 },
  { name: "29/64", size: 0.453125 },
  { name: "15/32", size: 0.46875 },
  { name: "31/64", size: 0.484375 },
  { name: "1/2", size: 0.5 },
];

export const findClosestDrillSize = (value) => {
  let closest = DRILL_SIZES[0];

  DRILL_SIZES.forEach((drill) => {
    if (Math.abs(drill.size - value) < Math.abs(closest.size - value)) {
      closest = drill;
    }
  });

  return closest;
};

export const findLargestDrillAtOrBelow = (value) => {
  const sorted = [...DRILL_SIZES].sort((a, b) => a.size - b.size);
  let best = sorted[0];

  for (const drill of sorted) {
    if (drill.size <= value) {
      best = drill;
    } else {
      break;
    }
  }

  return best;
};

const parseDecimalOrFraction = (value) => {
  if (typeof value === "number") return value;
  const text = String(value || "").trim();
  if (!text) return NaN;

  if (text.includes("/")) {
    const mixedMatch = text.match(/^(\d+(?:\.\d+)?)\s+(\d+(?:\.\d+)?)\/(\d+(?:\.\d+)?)$/);
    if (mixedMatch) {
      return Number(mixedMatch[1]) + Number(mixedMatch[2]) / Number(mixedMatch[3]);
    }

    const fractionMatch = text.match(/^(\d+(?:\.\d+)?)\/(\d+(?:\.\d+)?)$/);
    if (fractionMatch) {
      return Number(fractionMatch[1]) / Number(fractionMatch[2]);
    }
  }

  return Number(text.replace(/[^0-9.-]/g, ""));
};

//////////////////////////////////////////////////
// HOLE CLEARANCE DATABASE
//////////////////////////////////////////////////

export const CLEARANCE_TABLE = {
  "#0": { close: 0.06, normal: 0.0635, loose: 0.07 },
  "#1": { close: 0.073, normal: 0.0785, loose: 0.089 },
  "#2": { close: 0.086, normal: 0.0935, loose: 0.104 },
  "#3": { close: 0.0995, normal: 0.104, loose: 0.116 },
  "#4": { close: 0.112, normal: 0.116, loose: 0.1285 },
  "#5": { close: 0.125, normal: 0.1285, loose: 0.144 },
  "#6": { close: 0.138, normal: 0.144, loose: 0.1495 },
  "#8": { close: 0.164, normal: 0.1695, loose: 0.177 },
  "#10": { close: 0.19, normal: 0.196, loose: 0.201 },
  "#12": { close: 0.216, normal: 0.221, loose: 0.228 },
  "1/4": { close: 0.257, normal: 0.266, loose: 0.281 },
  "5/16": { close: 0.328, normal: 0.339, loose: 0.359 },
  "3/8": { close: 0.391, normal: 0.406, loose: 0.438 },
  "7/16": { close: 0.453, normal: 0.469, loose: 0.5 },
  "1/2": { close: 0.516, normal: 0.531, loose: 0.563 },
  "9/16": { close: 0.578, normal: 0.594, loose: 0.625 },
  "5/8": { close: 0.641, normal: 0.656, loose: 0.688 },
  "3/4": { close: 0.766, normal: 0.781, loose: 0.813 },
  "7/8": { close: 0.891, normal: 0.906, loose: 0.938 },
  "1": { close: 1.016, normal: 1.031, loose: 1.063 },
  "1-1/8": { close: 1.141, normal: 1.156, loose: 1.188 },
  "1-1/4": { close: 1.266, normal: 1.281, loose: 1.313 },
  "1-3/8": { close: 1.391, normal: 1.406, loose: 1.438 },
  "1-1/2": { close: 1.516, normal: 1.531, loose: 1.563 },
};

export const METRIC_CLEARANCE_TABLE = {
  M1: { close: 1.2, normal: 1.4, loose: 1.6 },
  "M1.2": { close: 1.4, normal: 1.6, loose: 1.8 },
  "M1.6": { close: 1.8, normal: 2.0, loose: 2.4 },
  M2: { close: 2.2, normal: 2.4, loose: 2.6 },
  "M2.5": { close: 2.7, normal: 2.9, loose: 3.1 },
  M3: { close: 3.2, normal: 3.4, loose: 3.6 },
  "M3.5": { close: 3.7, normal: 3.9, loose: 4.2 },
  M4: { close: 4.3, normal: 4.5, loose: 4.8 },
  M5: { close: 5.3, normal: 5.5, loose: 5.8 },
  M6: { close: 6.4, normal: 6.6, loose: 7.0 },
  M8: { close: 8.4, normal: 9.0, loose: 10.0 },
  M10: { close: 10.5, normal: 11.0, loose: 12.0 },
  M12: { close: 13.0, normal: 13.5, loose: 14.5 },
  M14: { close: 15.0, normal: 15.5, loose: 16.5 },
  M16: { close: 17.0, normal: 17.5, loose: 18.5 },
  M20: { close: 21.0, normal: 22.0, loose: 24.0 },
  M24: { close: 25.0, normal: 26.0, loose: 28.0 },
  M30: { close: 31.0, normal: 33.0, loose: 35.0 },
  M36: { close: 37.0, normal: 39.0, loose: 42.0 },
};

export const HOLE_CALCULATION_MODES = {
  standard: "standard",
  custom: "custom",
};

export const HOLE_MAKING_PROCESSES = {
  drill: "drill",
  drill_ream: "drill_ream",
  drill_bore: "drill_bore",
  bore_only: "bore_only",
};

export const HOLE_MAKING_CONDITIONS = {
  sharp_rigid: "sharp_rigid",
  normal: "normal",
  worn: "worn",
  high_runout: "high_runout",
};

const format4 = (value) => Number(value.toFixed(4));
const format3 = (value) => Number(value.toFixed(3));
const format5 = (value) => Number(value.toFixed(5));

const getDrillOversizeBase = (holeSize) => {
  if (holeSize <= 0.125) return 0.001;
  if (holeSize <= 0.25) return 0.0015;
  if (holeSize <= 0.5) return 0.002;
  if (holeSize <= 0.75) return 0.0025;
  if (holeSize <= 1.0) return 0.0035;
  return 0.0045;
};

const getConditionOversizeAdjustment = (condition) => {
  switch (condition) {
    case HOLE_MAKING_CONDITIONS.sharp_rigid:
      return { min: -0.0005, max: 0.0015 };
    case HOLE_MAKING_CONDITIONS.normal:
      return { min: 0.0, max: 0.0025 };
    case HOLE_MAKING_CONDITIONS.worn:
      return { min: 0.001, max: 0.0045 };
    case HOLE_MAKING_CONDITIONS.high_runout:
      return { min: 0.0015, max: 0.006 };
    default:
      return { min: 0.0, max: 0.0025 };
  }
};

const getReamAllowance = (targetHoleSize) => {
  if (targetHoleSize <= 0.125) return { min: 0.003, max: 0.005 };
  if (targetHoleSize <= 0.25) return { min: 0.004, max: 0.006 };
  if (targetHoleSize <= 0.5) return { min: 0.005, max: 0.01 };
  if (targetHoleSize <= 0.75) return { min: 0.006, max: 0.012 };
  if (targetHoleSize <= 1.0) return { min: 0.008, max: 0.015 };
  return { min: 0.01, max: 0.02 };
};

const getBoreAllowance = (targetHoleSize) => {
  if (targetHoleSize <= 0.25) return { min: 0.01, max: 0.02 };
  if (targetHoleSize <= 0.5) return { min: 0.015, max: 0.03 };
  if (targetHoleSize <= 1.0) return { min: 0.02, max: 0.04 };
  return { min: 0.03, max: 0.06 };
};

const getTargetHoleSize = (params, errors) => {
  const { mode, boltSize, fit, customHoleSize, standard = "asme_inch" } = params;
  const isMetricStandard = standard === "iso_metric";

  if (mode === HOLE_CALCULATION_MODES.custom) {
    const numeric = Number(customHoleSize);
    if (!numeric || numeric <= 0) {
      errors.customHoleSize = "Custom hole size must be greater than zero";
      return null;
    }
    return isMetricStandard ? numeric * MM_TO_INCH : numeric;
  }

  const table = isMetricStandard ? METRIC_CLEARANCE_TABLE : CLEARANCE_TABLE;
  const sizeData = table[boltSize];
  if (!sizeData) {
    errors.boltSize = "Invalid fastener size";
    return null;
  }

  const holeSize = sizeData[fit];
  if (!holeSize) {
    errors.fit = "Invalid fit type";
    return null;
  }

  return isMetricStandard ? holeSize * MM_TO_INCH : holeSize;
};

const buildDrillOnlyRecommendation = (targetHoleSize, condition) => {
  const recommendedDrill = findLargestDrillAtOrBelow(targetHoleSize);
  const baseOversize = getDrillOversizeBase(recommendedDrill.size);
  const adj = getConditionOversizeAdjustment(condition);

  const expectedMin = recommendedDrill.size + baseOversize + adj.min;
  const expectedMax = recommendedDrill.size + baseOversize + adj.max;

  return {
    recommendedDrill,
    expectedHoleMin: format4(expectedMin),
    expectedHoleMax: format4(expectedMax),
    prepHoleMin: null,
    prepHoleMax: null,
    allowanceMin: null,
    allowanceMax: null,
  };
};

const buildReamRecommendation = (targetHoleSize, condition) => {
  const allowance = getReamAllowance(targetHoleSize);
  const prepHoleTarget = targetHoleSize - (allowance.min + allowance.max) / 2;
  const prepDrill = findLargestDrillAtOrBelow(prepHoleTarget);

  const baseOversize = getDrillOversizeBase(prepDrill.size);
  const adj = getConditionOversizeAdjustment(condition);

  return {
    recommendedDrill: prepDrill,
    expectedHoleMin: format4(targetHoleSize - 0.0002),
    expectedHoleMax: format4(targetHoleSize + 0.0005),
    prepHoleMin: format4(prepDrill.size + baseOversize + adj.min),
    prepHoleMax: format4(prepDrill.size + baseOversize + adj.max),
    allowanceMin: format4(allowance.min),
    allowanceMax: format4(allowance.max),
  };
};

const buildBoreRecommendation = (targetHoleSize, condition, process) => {
  const allowance = getBoreAllowance(targetHoleSize);

  if (process === HOLE_MAKING_PROCESSES.bore_only) {
    return {
      recommendedDrill: null,
      expectedHoleMin: format4(targetHoleSize - 0.0005),
      expectedHoleMax: format4(targetHoleSize + 0.0005),
      prepHoleMin: format4(targetHoleSize - allowance.max),
      prepHoleMax: format4(targetHoleSize - allowance.min),
      allowanceMin: format4(allowance.min),
      allowanceMax: format4(allowance.max),
    };
  }

  const prepHoleTarget = targetHoleSize - (allowance.min + allowance.max) / 2;
  const prepDrill = findLargestDrillAtOrBelow(prepHoleTarget);

  const baseOversize = getDrillOversizeBase(prepDrill.size);
  const adj = getConditionOversizeAdjustment(condition);

  return {
    recommendedDrill: prepDrill,
    expectedHoleMin: format4(targetHoleSize - 0.0005),
    expectedHoleMax: format4(targetHoleSize + 0.0005),
    prepHoleMin: format4(prepDrill.size + baseOversize + adj.min),
    prepHoleMax: format4(prepDrill.size + baseOversize + adj.max),
    allowanceMin: format4(allowance.min),
    allowanceMax: format4(allowance.max),
  };
};

const getProcessNotes = (process, condition) => {
  const notes = [];

  if (process === HOLE_MAKING_PROCESSES.drill) {
    notes.push("Drill-only holes often finish slightly oversize compared to drill diameter.");
    notes.push("Actual size depends heavily on setup rigidity, tool geometry, and spindle runout.");
  }

  if (process === HOLE_MAKING_PROCESSES.drill_ream) {
    notes.push("Reaming is best when you need a more controlled final size and better finish.");
    notes.push("Leave enough stock for the reamer to cut cleanly without rubbing.");
  }

  if (
    process === HOLE_MAKING_PROCESSES.drill_bore ||
    process === HOLE_MAKING_PROCESSES.bore_only
  ) {
    notes.push("Boring is better than drilling when final hole size and concentricity matter.");
    notes.push("A boring head or fine boring tool is preferred for dialing in exact size.");
  }

  if (condition === HOLE_MAKING_CONDITIONS.worn) {
    notes.push("Worn drills can push hole size larger and reduce repeatability.");
  }

  if (condition === HOLE_MAKING_CONDITIONS.high_runout) {
    notes.push("High runout or weak setup can make actual drilled holes significantly oversized.");
  }

  return notes;
};

//////////////////////////////////////////////////
// THREAD HELPERS
//////////////////////////////////////////////////

const INCH_TO_MM = 25.4;
const MM_TO_INCH = 1 / 25.4;

const roundByUnit = (value, unit) =>
  unit === "metric" ? format3(value) : format4(value);

const toInches = (value, unit) => (unit === "metric" ? value * MM_TO_INCH : value);
const toMillimeters = (value, unit) => (unit === "metric" ? value : value * INCH_TO_MM);

const buildTapDrillDisplay = (tapDrillValue, unit) => {
  if (unit === "metric") {
    const inchEquivalent = tapDrillValue * MM_TO_INCH;
    const closest = findClosestDrillSize(inchEquivalent);

    return `${format3(tapDrillValue)} mm (${closest.name} / ${format4(
      closest.size
    )}")`;
  }

  const closest = findClosestDrillSize(tapDrillValue);
  return `${format4(tapDrillValue)}" (${closest.name})`;
};

const buildPipeTapDrillResult = (preset, pitch) => {
  if (!preset) return null;

  const isMetric = preset.unit === "metric";
  const drillMetric = preset.tapDrillMm || (isMetric ? preset.majorDiameter - pitch : null);
  const drillInch = preset.tapDrillInch || (drillMetric ? drillMetric * MM_TO_INCH : null);

  if (!drillMetric && !drillInch) {
    return {
      drillInch: null,
      drillMetric: null,
      display: "Verify tap drill from the applicable pipe-thread standard or tap manufacturer.",
      conservativeDisplay: "Not listed",
    };
  }

  const inchValue = drillInch || drillMetric * MM_TO_INCH;
  const metricValue = drillMetric || drillInch * INCH_TO_MM;
  const display = preset.tapDrillLabel
    ? `${preset.tapDrillLabel}${preset.unit === "inch" ? ` (${format3(metricValue)} mm)` : ` (${format4(inchValue)} in)`}`
    : `${format4(inchValue)} in / ${format3(metricValue)} mm`;

  return {
    drillInch: inchValue,
    drillMetric: metricValue,
    display,
    conservativeDisplay: display,
  };
};

const getPipeThreadNotes = (preset) => {
  const notes = [
    `${preset.label} is a pipe-thread preset based on ${preset.standard}.`,
    `${preset.threadSeries} uses a ${preset.angle}-degree thread form and ${preset.taper}.`,
    "Nominal pipe size is not the measured thread outside diameter; use the listed major diameter for calculations and identification.",
  ];

  if (preset.threadSeries === "NPT") {
    notes.push("NPT sealing depends on taper engagement and thread sealant. Verify hand-tight engagement, wrench makeup, and gaging requirements for pressure work.");
  }

  if (preset.threadSeries === "NPTF") {
    notes.push("NPTF is a dryseal pipe thread. Do not substitute ordinary NPT acceptance without confirming the drawing, gage, and sealing requirement.");
  }

  if (preset.threadSeries === "NPSC") {
    notes.push("NPSC is a straight pipe thread commonly used with an external NPT member. Verify the application because it is not the same as a tapered internal NPT thread.");
  }

  if (preset.threadSeries === "BSPP") {
    notes.push("BSPP / G threads are parallel; sealing normally uses a washer, O-ring, gasket, or bonded seal rather than thread taper.");
  }

  if (preset.threadSeries === "BSPT") {
    notes.push("BSPT / R threads are tapered Whitworth pipe threads. Verify mating Rp/Rc thread callout and sealing practice.");
  }

  return notes;
};

const resolveThreadPitch = (params, errors) => {
  const { unit = "inch", threadsPerInch, pitch } = params;

  if (unit === "metric") {
    if (!pitch || pitch <= 0) {
      errors.pitch = "Pitch must be greater than zero";
      return null;
    }
    return Number(pitch);
  }

  if (threadsPerInch && threadsPerInch > 0) {
    return 1 / Number(threadsPerInch);
  }

  if (pitch && pitch > 0) {
    return Number(pitch);
  }

  errors.threadsPerInch = "Threads per inch or pitch must be greater than zero";
  return null;
};

//////////////////////////////////////////////////
// SURFACE SPEED
//////////////////////////////////////////////////

export const calculateSurfaceSpeed = (params) => {
  const isLathe = ["cnc_lathe", "manual_lathe"].includes(params.machineType) ||
    String(params.machineType || "").toLowerCase().includes("lathe");
  const diameterField = isLathe ? "stockDiameter" : "toolDiameter";
  const errors = validateInputs(params, ["rpm", diameterField]);
  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const { rpm } = params;
  const diameter = Number(params[diameterField]);

  if (rpm <= 0) errors.rpm = "RPM must be positive";
  if (diameter <= 0) errors[diameterField] = isLathe ?
    "Stock diameter must be positive" :
    "Tool diameter must be positive";

  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const surfaceSpeed = (Math.PI * diameter * rpm) / 12;

  return {
    surfaceSpeed: Math.round(surfaceSpeed),
    diameterBasis: isLathe ? "Stock diameter" : "Tool diameter",
    warnings: surfaceSpeed > 1000 ? ["Very high surface speed"] : [],
    confidence: "High",
  };
};

//////////////////////////////////////////////////
// FEEDS & SPEEDS
//////////////////////////////////////////////////
const clampNumber = (value, min, max) => Math.min(max, Math.max(min, value));

export const FEEDS_SPEEDS_OPERATIONS = {
  cnc_mill: [
    { id: "face_milling", label: "Face Milling", diameterBasis: "tool", feedMode: "chip_load", sfm: 0.9, feed: 0.9, note: "Use cutter diameter for RPM. Feed is chip load per tooth converted to feed per minute." },
    { id: "side_milling", label: "Side Milling / Profiling", diameterBasis: "tool", feedMode: "chip_load", sfm: 1, feed: 1, note: "Use cutter diameter for RPM and chip load per tooth for feedrate." },
    { id: "slotting", label: "Slotting", diameterBasis: "tool", feedMode: "chip_load", sfm: 0.75, feed: 0.65, note: "Full-width slotting is heavier than profiling. Reduce feed and watch chip evacuation." },
    { id: "pocketing", label: "Pocketing", diameterBasis: "tool", feedMode: "chip_load", sfm: 0.9, feed: 0.8, note: "Use cutter diameter. Adjust for radial engagement, ramping, and chip evacuation." },
    { id: "drilling", label: "Drilling", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.7, feed: 0.75, note: "Use drill diameter for RPM. Feed is calculated in/rev or mm/rev, with feed/min shown as a machine reference." },
    { id: "reaming", label: "Reaming", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.45, feed: 0.55, note: "Reaming usually runs slower than drilling with steady feed and proper stock allowance." },
    { id: "chamfering", label: "Chamfering / Deburring", diameterBasis: "tool", feedMode: "chip_load", sfm: 0.8, feed: 0.55, note: "Use effective tool diameter at the contact point when known." },
  ],
  manual_mill: [
    { id: "manual_side_milling", label: "Manual Side Milling", diameterBasis: "tool", feedMode: "chip_load", sfm: 0.65, feed: 0.65, note: "Manual mill values are reduced for hand feed, rigidity, and feel." },
    { id: "manual_slotting", label: "Manual Slotting", diameterBasis: "tool", feedMode: "chip_load", sfm: 0.55, feed: 0.5, note: "Slotting by hand needs conservative feed and good chip clearing." },
    { id: "manual_drilling", label: "Manual Mill Drilling", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.55, feed: 0.6, note: "Use drill diameter for RPM. Feed per revolution is a starting point for quill feed feel." },
    { id: "manual_reaming", label: "Manual Mill Reaming", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.38, feed: 0.5, note: "Use slow speed, steady feed, and correct drilled allowance before reaming." },
    { id: "manual_boring", label: "Manual Mill Boring Head", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.45, feed: 0.45, note: "Use approximate bore/cutter sweep diameter and light feed for boring head work." },
  ],
  drill_press: [
    { id: "drill_press_drilling", label: "Drilling", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.5, feed: 0.55, note: "Use drill diameter for RPM. Feed is a starting in/rev value; many drill presses are fed by feel." },
    { id: "drill_press_reaming", label: "Reaming", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.35, feed: 0.5, note: "Reaming needs slower speed, steady feed, and enough stock for the reamer to cut." },
    { id: "drill_press_countersink", label: "Countersinking", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.35, feed: 0.35, note: "Use the effective countersink diameter and reduce speed to avoid chatter." },
    { id: "drill_press_tapping", label: "Tapping", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.25, feed: 0.35, note: "Use tap major diameter for RPM. Feed must match thread pitch when power tapping." },
  ],
  cnc_lathe: [
    { id: "od_rough_turning", label: "OD Rough Turning", diameterBasis: "stock", feedMode: "feed_per_rev", sfm: 0.95, feed: 1, note: "Use current stock/work diameter for RPM. Feed is per revolution." },
    { id: "od_finish_turning", label: "OD Finish Turning", diameterBasis: "stock", feedMode: "feed_per_rev", sfm: 1, feed: 0.45, note: "Use work diameter. Finish feed depends heavily on nose radius and finish requirement." },
    { id: "facing", label: "Facing", diameterBasis: "stock", feedMode: "feed_per_rev", sfm: 0.9, feed: 0.75, note: "Use outside stock diameter as the starting RPM basis; surface speed falls toward center." },
    { id: "id_boring", label: "ID Boring", diameterBasis: "stock", feedMode: "feed_per_rev", sfm: 0.75, feed: 0.55, note: "Use bore/work diameter and reduce for bar overhang and chatter risk." },
    { id: "grooving", label: "Grooving", diameterBasis: "stock", feedMode: "feed_per_rev", sfm: 0.55, feed: 0.32, note: "Grooving and parting use conservative speed/feed due to tool width and chip control." },
    { id: "parting", label: "Parting Off", diameterBasis: "stock", feedMode: "feed_per_rev", sfm: 0.45, feed: 0.28, note: "Parting values assume rigid setup, sharp insert, correct center height, and good coolant." },
    { id: "lathe_center_drill", label: "Center Drill on Spindle Centerline", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.45, feed: 0.4, note: "Use center drill body/contact diameter, not stock OD, for RPM." },
    { id: "lathe_tailstock_drill", label: "Drill with Tailstock", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.5, feed: 0.5, note: "Use drill diameter for RPM. Feed is in/rev or mm/rev; tailstock pressure and chip clearing limit actual feed." },
    { id: "lathe_ream", label: "Ream with Tailstock", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.35, feed: 0.45, note: "Use reamer diameter, slow speed, steady feed, and correct drilled allowance." },
  ],
  manual_lathe: [
    { id: "manual_od_turning", label: "Manual OD Turning", diameterBasis: "stock", feedMode: "feed_per_rev", sfm: 0.6, feed: 0.7, note: "Use current stock/work diameter for RPM. Feed is per revolution from gearbox/feed dial." },
    { id: "manual_finish_turning", label: "Manual Finish Turning", diameterBasis: "stock", feedMode: "feed_per_rev", sfm: 0.62, feed: 0.35, note: "Finish feed depends on nose radius, tool sharpness, machine condition, and finish requirement." },
    { id: "manual_facing", label: "Manual Facing", diameterBasis: "stock", feedMode: "feed_per_rev", sfm: 0.55, feed: 0.55, note: "Use stock OD for starting RPM; be cautious near center where cutting speed drops." },
    { id: "manual_boring", label: "Manual ID Boring", diameterBasis: "stock", feedMode: "feed_per_rev", sfm: 0.45, feed: 0.4, note: "Use bore/work diameter and reduce for boring bar overhang." },
    { id: "manual_parting", label: "Manual Parting / Grooving", diameterBasis: "stock", feedMode: "feed_per_rev", sfm: 0.35, feed: 0.25, note: "Parting on a manual lathe needs rigid setup, center-height control, and conservative feed." },
    { id: "manual_center_drill", label: "Center Drill with Tailstock", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.4, feed: 0.35, note: "Use center drill contact diameter, not stock OD, for RPM." },
    { id: "manual_tailstock_drill", label: "Drill with Tailstock", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.42, feed: 0.45, note: "Use drill diameter for RPM. Feed is in/rev or mm/rev; actual feed is limited by tailstock feel, drill size, and chip clearing." },
    { id: "manual_tailstock_ream", label: "Ream with Tailstock", diameterBasis: "tool", feedMode: "feed_per_rev", sfm: 0.3, feed: 0.4, note: "Use reamer diameter and feed steadily. Do not dwell." },
  ],
};

const getFeedsSpeedsOperation = (machineType, operationId) => {
  const operations = FEEDS_SPEEDS_OPERATIONS[machineType] || FEEDS_SPEEDS_OPERATIONS.cnc_mill;
  return operations.find((operation) => operation.id === operationId) || operations[0];
};

const calculateTurningFeedPerRev = ({
  materialData,
  toolMaterial,
  coating,
  machineType,
  stockDiameter,
  operation,
}) => {
  const materialFeedByGroup = {
    aluminum: 0.008,
    steel: 0.006,
    stainless: 0.0045,
    hardox: 0.003,
    tool_steel: 0.0038,
    cast_iron: 0.006,
    copper_alloy: 0.007,
    superalloy: 0.0028,
    plastic: 0.01,
  };

  const toolFeedFactor = {
    hss: 0.72,
    cobalt: 0.82,
    carbide: 1,
    ceramic: 1.12,
    cermet: 1.05,
    cbn: 0.95,
    pcd: 1.15,
  };

  const machineFeedFactor = {
    cnc_lathe: 1,
    manual_lathe: 0.75,
  };

  const baseFeed = materialFeedByGroup[materialData.group] || 0.005;
  const hardnessHB = Number(materialData.hardnessHB) || 180;
  const hardnessFactor = clampNumber(220 / Math.max(hardnessHB, 80), 0.45, 1.25);
  const diameterFactor = clampNumber(Math.sqrt(Math.max(Number(stockDiameter), 0.125) / 1.5), 0.75, 1.25);
  const calculatedFeed =
    baseFeed *
    (toolFeedFactor[toolMaterial] || 1) *
    (machineFeedFactor[machineType] || 1) *
    coating.feedMultiplier *
    (operation?.feed || 1) *
    hardnessFactor *
    diameterFactor;

  return clampNumber(calculatedFeed, 0.001, 0.018);
};

const calculateDrillingFeedPerRev = ({ materialData, toolMaterial, coating, diameter, operation }) => {
  const materialFeedByGroup = {
    aluminum: 0.006,
    steel: 0.004,
    stainless: 0.0028,
    hardox: 0.0018,
    tool_steel: 0.0022,
    cast_iron: 0.0045,
    copper_alloy: 0.004,
    superalloy: 0.0015,
    plastic: 0.007,
  };
  const toolFeedFactor = {
    hss: 0.78,
    cobalt: 0.9,
    carbide: 1.1,
    ceramic: 0.45,
    cermet: 0.65,
    cbn: 0.4,
    pcd: 1.15,
  };
  const diameterFactor = clampNumber(Math.sqrt(Math.max(Number(diameter), 0.0625) / 0.25), 0.55, 1.8);
  const hardnessHB = Number(materialData.hardnessHB) || 180;
  const hardnessFactor = clampNumber(200 / Math.max(hardnessHB, 80), 0.4, 1.2);
  const baseFeed = materialFeedByGroup[materialData.group] || 0.0035;
  return clampNumber(
    baseFeed *
      diameterFactor *
      hardnessFactor *
      (toolFeedFactor[toolMaterial] || 1) *
      coating.feedMultiplier *
      (operation?.feed || 1),
    0.0005,
    0.02
  );
};

export const calculateFeedsSpeeds = (params) => {
  const operation = getFeedsSpeedsOperation(params.machineType || "cnc_mill", params.operation);
  const isLathe = ["cnc_lathe", "manual_lathe"].includes(params.machineType);
  const usesChipLoad = operation.feedMode === "chip_load";
  const diameterField = operation.diameterBasis === "stock" ? "stockDiameter" : "toolDiameter";
  const errors = validateInputs(params, [
    "material",
    "toolMaterial",
    "operation",
    diameterField,
    ...(usesChipLoad ? ["flutes", "chipLoad"] : []),
  ]);
  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const {
    material,
    toolMaterial,
    toolDiameter,
    stockDiameter,
    flutes,
    chipLoad,
    machineType = "cnc_mill",
    toolCoating = "uncoated",
    sfmOverride,
    feedOverride,
    machineMaxRPM,
    machineHorsepower,
    rigidityFactor = 1,
    stickout,
    radialEngagement,
    coolantMode = "flood",
  } = params;
  const rpmDiameter = operation.diameterBasis === "stock" ? Number(stockDiameter) : Number(toolDiameter);

  if (rpmDiameter <= 0) {
    if (operation.diameterBasis === "stock") {
      errors.stockDiameter = "Stock diameter must be positive";
    } else {
      errors.toolDiameter = operation.feedMode === "feed_per_rev" ? "Cutting diameter must be positive" : "Tool diameter must be positive";
    }
  }
  if (usesChipLoad && flutes <= 0) errors.flutes = "Number of flutes must be positive";
  if (usesChipLoad && chipLoad <= 0) errors.chipLoad = "Chip load must be positive";

  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const machineFactors = {
    cnc_mill: { sfm: 1, feed: 1, label: "CNC mill" },
    cnc_lathe: { sfm: 0.95, feed: 0.95, label: "CNC lathe" },
    manual_mill: { sfm: 0.65, feed: 0.75, label: "manual mill" },
    manual_lathe: { sfm: 0.6, feed: 0.7, label: "manual lathe" },
    drill_press: { sfm: 0.5, feed: 0.55, label: "drill press" },
  };
  const machine = machineFactors[machineType] || machineFactors.cnc_mill;

  const factor = MATERIAL_DATABASE[material] || MATERIAL_DATABASE.aluminum_6061;
  const toolMultiplier = TOOL_MATERIAL_MULTIPLIERS[toolMaterial];
  const coating = TOOL_COATINGS[toolCoating] || TOOL_COATINGS.uncoated;
  if (!toolMultiplier) errors.toolMaterial = "Invalid tool material";
  if (!coating) errors.toolCoating = "Invalid tool coating";

  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const stickoutRatio = Number(stickout) > 0 ? Number(stickout) / Math.max(rpmDiameter, 0.0001) : null;
  const stickoutDerate = stickoutRatio && stickoutRatio > 4 ? clampNumber(4 / stickoutRatio, 0.45, 1) : 1;
  const engagementRatio = Number(radialEngagement) > 0 ? Number(radialEngagement) / Math.max(rpmDiameter, 0.0001) : null;
  const engagementDerate = usesChipLoad && engagementRatio && engagementRatio > 0.5 ? 0.82 : 1;
  const coolantDerate = coolantMode === "dry" && ["stainless", "hardox", "tool_steel", "spring_steel", "superalloy"].includes(factor.group) ? 0.78 : 1;
  const rigidity = clampNumber((Number(rigidityFactor) || 1) * stickoutDerate * engagementDerate * coolantDerate, 0.35, 1.25);
  const calculatedSFM = factor.sfm * machine.sfm * operation.sfm * toolMultiplier * coating.sfmMultiplier * rigidity;
  const optimalSFM = Number(sfmOverride) > 0 ? Number(sfmOverride) : calculatedSFM;
  const calculatedRPM = (optimalSFM * 12) / (Math.PI * rpmDiameter);
  const optimalRPM = Number(machineMaxRPM) > 0 ? Math.min(calculatedRPM, Number(machineMaxRPM)) : calculatedRPM;
  const adjustedChipLoad = usesChipLoad
    ? factor.chipLoad * machine.feed * operation.feed * coating.feedMultiplier * rigidity
    : isLathe && operation.diameterBasis === "stock"
    ? calculateTurningFeedPerRev({
        materialData: factor,
        toolMaterial,
        coating,
        machineType,
        stockDiameter: rpmDiameter,
        operation,
      })
    : calculateDrillingFeedPerRev({
        materialData: factor,
        toolMaterial,
        coating,
        diameter: rpmDiameter,
        operation,
      });
  const advancedFeedInput = Number(feedOverride) > 0 ? Number(feedOverride) : null;
  const effectiveChipOrFeed = advancedFeedInput || (usesChipLoad ? Number(chipLoad) : adjustedChipLoad);
  const optimalFeed = usesChipLoad ? optimalRPM * flutes * adjustedChipLoad : adjustedChipLoad;
  const feedRate = usesChipLoad ? optimalRPM * flutes * effectiveChipOrFeed : effectiveChipOrFeed;
  const feedPerMinute = usesChipLoad ? optimalRPM * effectiveChipOrFeed * flutes : optimalRPM * effectiveChipOrFeed;
  const optimalFeedPerMinute = usesChipLoad ? optimalRPM * adjustedChipLoad * flutes : optimalRPM * adjustedChipLoad;

  const warnings = [];
  warnings.push("Feeds and speeds are starting points. Verify with tooling manufacturer data, machine rigidity, coolant, setup, and tool condition.");
  if (usesChipLoad && feedRate < optimalFeed * 0.5) warnings.push("Feed rate too low - inefficient cutting");
  if (optimalRPM > 20000) warnings.push("Calculated RPM is very high. Verify machine maximum RPM, balance, runout, holder rating, and manufacturer cutting data.");
  if (Number(machineMaxRPM) > 0 && calculatedRPM > Number(machineMaxRPM)) warnings.push(`RPM was capped at the advanced machine maximum of ${Number(machineMaxRPM)} RPM.`);
  if (Number(machineHorsepower) > 0 && usesChipLoad) {
    const estimatedMrr = Math.max(0, Number(radialEngagement || rpmDiameter * 0.35)) * Math.max(0.001, rpmDiameter * 0.2) * Math.max(0, feedRate);
    const unitHp = factor.group === "aluminum" ? 0.25 : factor.group === "steel" ? 1 : factor.group === "stainless" ? 1.25 : factor.group === "spring_steel" ? 1.15 : factor.group === "superalloy" ? 1.8 : 1;
    const estimatedHp = estimatedMrr * unitHp;
    if (estimatedHp > Number(machineHorsepower) * 0.8) warnings.push(`Estimated roughing horsepower demand may approach the ${Number(machineHorsepower)} HP machine limit. Reduce width/depth/feed or verify spindle load.`);
  }
  if (stickoutRatio && stickoutRatio > 4) warnings.push(`Stickout is ${stickoutRatio.toFixed(1)}x diameter; speed/feed was derated for chatter risk.`);
  if (engagementRatio && engagementRatio > 0.5 && usesChipLoad) warnings.push("Radial engagement is above 50% of tool diameter; feed was derated for heavier cutter load.");
  if (coolantMode === "dry" && coolantDerate < 1) warnings.push("Dry cutting selected for a heat-sensitive or work-hardening material; speed/feed was derated.");
  if (Number(sfmOverride) > 0) warnings.push("Advanced SFM/Vc override is active. Verify the override against the toolmaker data and material condition.");
  if (advancedFeedInput) warnings.push(`Advanced ${usesChipLoad ? "chip load" : "feed per revolution"} override is active.`);
  if (!usesChipLoad && feedPerMinute > 80) warnings.push("Calculated feed per minute is high for a feed-per-revolution operation. Verify machine feed limit, chip evacuation, and tool manufacturer's data.");
  if (!usesChipLoad && operation.id.includes("tapping")) warnings.push("Power tapping feed must match the thread pitch exactly; use the thread pitch/tap drill calculator for pitch-specific feed.");
  if (machineType === "drill_press") {
    warnings.push("Drill press values assume drilling-style rigidity. Reduce feed for large drills, thin stock, or weak workholding.");
  }
  if (toolMaterial !== "carbide") {
    warnings.push("Material SFM data is normalized around carbide-style starting values; tool material multipliers adjust from that baseline and should be checked against the toolmaker catalog.");
  }
  if (operation.note) warnings.push(operation.note);

  return {
    surfaceSpeed: Math.round(optimalSFM),
    feedRate: usesChipLoad ? Math.round(feedRate * 100) / 100 : Math.round(feedRate * 10000) / 10000,
    optimalRPM: Math.round(optimalRPM),
    optimalFeed: usesChipLoad ? Math.round(optimalFeed * 100) / 100 : Math.round(optimalFeed * 10000) / 10000,
    feedPerMinute: Math.round(feedPerMinute * 100) / 100,
    optimalFeedPerMinute: Math.round(optimalFeedPerMinute * 100) / 100,
    feedMode: usesChipLoad ? "per_minute" : "per_rev",
    operationId: operation.id,
    operationLabel: operation.label,
    operationNote: operation.note,
    materialLabel: factor.label || material,
    toolMaterial,
    toolCoating,
    coatingLabel: coating.label,
    machineType,
    machineLabel: machine.label,
    rpmDiameter,
    rpmDiameterLabel: operation.diameterBasis === "stock" ? "Stock / work diameter" : usesChipLoad ? "Tool diameter" : "Cutting diameter",
    baselineSFM: Math.round(optimalSFM),
    baselineChipLoad: Math.round(adjustedChipLoad * 10000) / 10000,
    calculatedRPM: Math.round(calculatedRPM),
    advancedAssumptions: {
      sfmOverride: Number(sfmOverride) > 0 ? Number(sfmOverride) : null,
      feedOverride: advancedFeedInput,
      machineMaxRPM: Number(machineMaxRPM) > 0 ? Number(machineMaxRPM) : null,
      machineHorsepower: Number(machineHorsepower) > 0 ? Number(machineHorsepower) : null,
      rigidityFactor: rigidity,
      stickoutRatio,
      radialEngagementRatio: engagementRatio,
      coolantMode,
    },
    formulas: usesChipLoad
      ? [
          "RPM = (SFM x 3.82) / diameter_in",
          "Metric RPM = (Vc x 1000) / (pi x diameter_mm)",
          "Milling feedrate = RPM x flute count x chip load per tooth",
        ]
      : [
          "RPM = (SFM x 3.82) / diameter_in",
          "Metric RPM = (Vc x 1000) / (pi x diameter_mm)",
          "Drilling/turning feedrate = RPM x feed per revolution",
        ],
    formulaSource: {
      source: "Machinery's Handbook style shop math and common tooling-catalog formulas",
      edition: "Formula is edition-stable; SFM/chip-load recommendations must be verified against the latest available handbook and manufacturer data.",
      assumptions: [
        "Material SFM table is a generic carbide-style starting point.",
        "Tool material, coating, machine, hardness, and operation multipliers estimate a starting value.",
        "Feed-per-revolution operations calculate feed per rev and show feed per minute only as a machine reference.",
      ],
      lastVerified: "2026-06-10",
    },
    warnings,
    confidence: warnings.length === 0 ? "High" : "Medium",
  };
};

//////////////////////////////////////////////////
// RPM
//////////////////////////////////////////////////

export const calculateRPM = (params) => {
  const isLathe = ["cnc_lathe", "manual_lathe"].includes(params.machineType);
  const errors = validateInputs(params, [
    "material",
    "toolMaterial",
    isLathe ? "stockDiameter" : "toolDiameter",
  ]);
  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const {
    material,
    toolMaterial,
    toolDiameter,
    stockDiameter,
    machineType = "cnc_mill",
    toolCoating = "uncoated",
  } = params;
  const rpmDiameter = isLathe ? Number(stockDiameter) : Number(toolDiameter);

  if (rpmDiameter <= 0) {
    if (isLathe) {
      errors.stockDiameter = "Stock diameter must be positive";
    } else {
      errors.toolDiameter = "Tool diameter must be positive";
    }
  }

  const materialData = MATERIAL_DATABASE[material];
  if (!materialData) {
    errors.material = "Invalid material";
  }

  const multiplier = TOOL_MATERIAL_MULTIPLIERS[toolMaterial];
  if (!multiplier) {
    errors.toolMaterial = "Invalid tool material";
  }
  const coating = TOOL_COATINGS[toolCoating] || TOOL_COATINGS.uncoated;
  if (!coating) {
    errors.toolCoating = "Invalid tool coating";
  }

  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const machineFactors = {
    cnc_mill: { sfm: 1, rpmMax: 12000, label: "CNC mill" },
    cnc_lathe: { sfm: 0.95, rpmMax: 5000, label: "CNC lathe" },
    manual_mill: { sfm: 0.65, rpmMax: 4200, label: "manual mill" },
    manual_lathe: { sfm: 0.6, rpmMax: 3000, label: "manual lathe" },
    drill_press: { sfm: 0.5, rpmMax: 3500, label: "drill press" },
  };
  const machine = machineFactors[machineType] || machineFactors.cnc_mill;
  const baseSFM = materialData.sfm * machine.sfm;
  const adjustedSFM = baseSFM * multiplier * coating.sfmMultiplier;
  const rpm = (adjustedSFM * 12) / (Math.PI * rpmDiameter);

  const warnings = [];

  if (toolMaterial === "hss" && adjustedSFM > baseSFM * 1.2) {
    warnings.push("High speed for HSS - tool wear risk");
  }

  if (rpm > machine.rpmMax) {
    warnings.push(`RPM exceeds typical ${machine.label} speed range. Verify machine limit before running.`);
  }

  return {
    rpm: Math.round(rpm),
    surfaceSpeed: Math.round(adjustedSFM),
    materialLabel: materialData.label || material,
    toolMaterial,
    toolCoating,
    coatingLabel: coating.label,
    machineType,
    machineLabel: machine.label,
    rpmDiameter,
    rpmDiameterLabel: isLathe ? "Stock diameter" : "Tool diameter",
    warnings,
    confidence: warnings.length === 0 ? "High" : "Medium",
  };
};

//////////////////////////////////////////////////
// TAP DRILL
//////////////////////////////////////////////////

const NPT_PIPE_THREAD_OPTIONS = [
  ["1/16", 27, 0.3125, 0.242, "C / 0.242 in", 0.16, 0.2611],
  ["1/8", 27, 0.405, 0.339, "R / 0.339 in", 0.18, 0.26],
  ["1/4", 18, 0.54, 0.4375, "7/16 in", 0.2, 0.401],
  ["3/8", 18, 0.675, 0.5781, "37/64 in", 0.24, 0.408],
  ["1/2", 14, 0.84, 0.7188, "23/32 in", 0.32, 0.534],
  ["3/4", 14, 1.05, 0.9219, "59/64 in", 0.34, 0.546],
  ["1", 11.5, 1.315, 1.1562, "1-5/32 in", 0.4, 0.682],
  ["1-1/4", 11.5, 1.66, 1.5, "1-1/2 in", 0.42, 0.707],
  ["1-1/2", 11.5, 1.9, 1.7344, "1-47/64 in", 0.42, 0.724],
  ["2", 11.5, 2.375, 2.2188, "2-7/32 in", 0.436, 0.756],
  ["2-1/2", 8, 2.875, 2.625, "2-5/8 in", 0.682, 1.136],
  ["3", 8, 3.5, 3.25, "3-1/4 in", 0.766, 1.2],
  ["3-1/2", 8, 4, 3.75, "3-3/4 in", 0.821, 1.25],
  ["4", 8, 4.5, 4.125, "4-1/8 in", 0.844, 1.3],
  ["5", 8, 5.563, null, "", 0.937, 1.4063],
].map(([size, tpi, majorDiameter, tapDrillInch, tapDrillLabel, handTightEngagement, effectiveThreadLength]) => ({
  value: `NPT-${size}`,
  label: `${size}-${tpi} NPT`,
  unit: "inch",
  majorDiameter,
  tpi,
  threadFamily: "pipe",
  threadSeries: "NPT",
  standard: "ASME B1.20.1",
  angle: 60,
  taper: "1:16 diameter taper, 3/4 in per foot",
  tapDrillInch,
  tapDrillLabel,
  handTightEngagement,
  effectiveThreadLength,
}));

const buildAmericanPipeThreadVariant = (source, series, standard, taper) =>
  source.map((thread) => ({
    ...thread,
    value: `${series}-${thread.value.replace("NPT-", "")}`,
    label: thread.label.replace("NPT", series),
    threadSeries: series,
    standard,
    taper,
  }));

const NPSC_TAP_DRILLS = {
  "1/8": { tapDrillInch: 0.348, tapDrillLabel: "S / 0.348 in" },
  "1/4": { tapDrillInch: 0.4531, tapDrillLabel: "29/64 in" },
  "3/8": { tapDrillInch: 0.5938, tapDrillLabel: "19/32 in" },
  "1/2": { tapDrillInch: 0.7344, tapDrillLabel: "47/64 in" },
  "3/4": { tapDrillInch: 0.9375, tapDrillLabel: "15/16 in" },
  "1": { tapDrillInch: 1.1875, tapDrillLabel: "1-3/16 in" },
  "1-1/4": { tapDrillInch: 1.5156, tapDrillLabel: "1-33/64 in" },
  "1-1/2": { tapDrillInch: 1.75, tapDrillLabel: "1-3/4 in" },
  "2": { tapDrillInch: 2.2188, tapDrillLabel: "2-7/32 in" },
  "2-1/2": { tapDrillInch: 2.6562, tapDrillLabel: "2-21/32 in" },
  "3": { tapDrillInch: 3.2812, tapDrillLabel: "3-9/32 in" },
  "3-1/2": { tapDrillInch: 3.7812, tapDrillLabel: "3-25/32 in" },
  "4": { tapDrillInch: 4.2812, tapDrillLabel: "4-9/32 in" },
};

const buildNpscPipeThreads = () =>
  NPT_PIPE_THREAD_OPTIONS.map((thread) => {
    const size = thread.value.replace("NPT-", "");
    const straightDrill = NPSC_TAP_DRILLS[size];
    return {
      ...thread,
      value: `NPSC-${size}`,
      label: thread.label.replace("NPT", "NPSC"),
      threadSeries: "NPSC",
      standard: "ASME B1.20.1 straight pipe thread practice",
      taper: "Parallel straight pipe thread for pressure-tight joints with sealant",
      tapDrillInch: straightDrill?.tapDrillInch || null,
      tapDrillLabel: straightDrill?.tapDrillLabel || "",
    };
  });

const BSP_BASE_SIZES = [
  ["1/16", 7.723, 28],
  ["1/8", 9.728, 28],
  ["1/4", 13.157, 19],
  ["3/8", 16.662, 19],
  ["1/2", 20.955, 14],
  ["5/8", 22.911, 14],
  ["3/4", 26.441, 14],
  ["7/8", 30.201, 14],
  ["1", 33.249, 11],
  ["1-1/8", 37.897, 11],
  ["1-1/4", 41.91, 11],
  ["1-1/2", 47.803, 11],
  ["1-3/4", 53.746, 11],
  ["2", 59.614, 11],
  ["2-1/4", 65.71, 11],
  ["2-1/2", 75.184, 11],
  ["2-3/4", 81.534, 11],
  ["3", 87.884, 11],
  ["3-1/2", 100.33, 11],
  ["4", 113.03, 11],
  ["4-1/2", 125.73, 11],
  ["5", 138.43, 11],
  ["5-1/2", 151.13, 11],
  ["6", 163.83, 11],
];

const buildBspPipeThreads = (series, prefix, standard, taper) =>
  BSP_BASE_SIZES.map(([size, majorDiameter, tpi]) => {
    const pitch = 25.4 / tpi;
    return {
      value: `${series}-${size}`,
      label: `${prefix} ${size} ${series}`,
      unit: "metric",
      majorDiameter,
      pitch,
      tpi,
      threadFamily: "pipe",
      threadSeries: series,
      standard,
      angle: 55,
      taper,
      tapDrillMm: majorDiameter - pitch,
      tapDrillLabel: `${format3(majorDiameter - pitch)} mm`,
    };
  });

export const PIPE_THREAD_SIZE_OPTIONS = [
  ...NPT_PIPE_THREAD_OPTIONS,
  ...buildAmericanPipeThreadVariant(
    NPT_PIPE_THREAD_OPTIONS,
    "NPTF",
    "ASME B1.20.3 / SAE dryseal pipe thread practice",
    "1:16 diameter taper, dryseal thread form"
  ),
  ...buildNpscPipeThreads(),
  ...buildBspPipeThreads("BSPP", "G", "ISO 228 / BS EN ISO 228", "Parallel pipe thread"),
  ...buildBspPipeThreads("BSPT", "R", "ISO 7-1 / BS EN 10226", "1:16 taper on tapered external/internal pipe threads"),
];

export const THREAD_SIZE_OPTIONS = [
  { value: "0-80", label: "#0-80 UNF", unit: "inch", majorDiameter: 0.06, tpi: 80 },
  { value: "1-64", label: "#1-64 UNC", unit: "inch", majorDiameter: 0.073, tpi: 64 },
  { value: "2-56", label: "#2-56 UNC", unit: "inch", majorDiameter: 0.086, tpi: 56 },
  { value: "4-40", label: "#4-40 UNC", unit: "inch", majorDiameter: 0.112, tpi: 40 },
  { value: "6-32", label: "#6-32 UNC", unit: "inch", majorDiameter: 0.138, tpi: 32 },
  { value: "8-32", label: "#8-32 UNC", unit: "inch", majorDiameter: 0.164, tpi: 32 },
  { value: "10-24", label: "#10-24 UNC", unit: "inch", majorDiameter: 0.19, tpi: 24 },
  { value: "10-32", label: "#10-32 UNF", unit: "inch", majorDiameter: 0.19, tpi: 32 },
  { value: "1/4-20", label: "1/4-20 UNC", unit: "inch", majorDiameter: 0.25, tpi: 20 },
  { value: "1/4-28", label: "1/4-28 UNF", unit: "inch", majorDiameter: 0.25, tpi: 28 },
  { value: "5/16-18", label: "5/16-18 UNC", unit: "inch", majorDiameter: 0.3125, tpi: 18 },
  { value: "5/16-24", label: "5/16-24 UNF", unit: "inch", majorDiameter: 0.3125, tpi: 24 },
  { value: "3/8-16", label: "3/8-16 UNC", unit: "inch", majorDiameter: 0.375, tpi: 16 },
  { value: "3/8-24", label: "3/8-24 UNF", unit: "inch", majorDiameter: 0.375, tpi: 24 },
  { value: "7/16-14", label: "7/16-14 UNC", unit: "inch", majorDiameter: 0.4375, tpi: 14 },
  { value: "7/16-20", label: "7/16-20 UNF", unit: "inch", majorDiameter: 0.4375, tpi: 20 },
  { value: "1/2-13", label: "1/2-13 UNC", unit: "inch", majorDiameter: 0.5, tpi: 13 },
  { value: "1/2-20", label: "1/2-20 UNF", unit: "inch", majorDiameter: 0.5, tpi: 20 },
  { value: "5/8-11", label: "5/8-11 UNC", unit: "inch", majorDiameter: 0.625, tpi: 11 },
  { value: "5/8-18", label: "5/8-18 UNF", unit: "inch", majorDiameter: 0.625, tpi: 18 },
  { value: "3/4-10", label: "3/4-10 UNC", unit: "inch", majorDiameter: 0.75, tpi: 10 },
  { value: "3/4-16", label: "3/4-16 UNF", unit: "inch", majorDiameter: 0.75, tpi: 16 },
  { value: "1-8", label: "1-8 UNC", unit: "inch", majorDiameter: 1, tpi: 8 },
  { value: "1-12", label: "1-12 UNF", unit: "inch", majorDiameter: 1, tpi: 12 },
  { value: "M3x0.5", label: "M3 x 0.5", unit: "metric", majorDiameter: 3, pitch: 0.5 },
  { value: "M4x0.7", label: "M4 x 0.7", unit: "metric", majorDiameter: 4, pitch: 0.7 },
  { value: "M5x0.8", label: "M5 x 0.8", unit: "metric", majorDiameter: 5, pitch: 0.8 },
  { value: "M6x1", label: "M6 x 1.0", unit: "metric", majorDiameter: 6, pitch: 1 },
  { value: "M8x1.25", label: "M8 x 1.25", unit: "metric", majorDiameter: 8, pitch: 1.25 },
  { value: "M10x1.5", label: "M10 x 1.5", unit: "metric", majorDiameter: 10, pitch: 1.5 },
  { value: "M12x1.75", label: "M12 x 1.75", unit: "metric", majorDiameter: 12, pitch: 1.75 },
  { value: "M16x2", label: "M16 x 2.0", unit: "metric", majorDiameter: 16, pitch: 2 },
  { value: "M20x2.5", label: "M20 x 2.5", unit: "metric", majorDiameter: 20, pitch: 2.5 },
  { value: "1/4-32", label: "1/4-32 UNEF", unit: "inch", majorDiameter: 0.25, tpi: 32 },
  { value: "5/16-32", label: "5/16-32 UNEF", unit: "inch", majorDiameter: 0.3125, tpi: 32 },
  { value: "3/8-32", label: "3/8-32 UNEF", unit: "inch", majorDiameter: 0.375, tpi: 32 },
  { value: "7/16-28", label: "7/16-28 UNEF", unit: "inch", majorDiameter: 0.4375, tpi: 28 },
  { value: "1/2-28", label: "1/2-28 UNEF", unit: "inch", majorDiameter: 0.5, tpi: 28 },
  { value: "9/16-12", label: "9/16-12 UNC", unit: "inch", majorDiameter: 0.5625, tpi: 12 },
  { value: "9/16-18", label: "9/16-18 UNF", unit: "inch", majorDiameter: 0.5625, tpi: 18 },
  { value: "11/16-24", label: "11/16-24 UNEF", unit: "inch", majorDiameter: 0.6875, tpi: 24 },
  { value: "7/8-9", label: "7/8-9 UNC", unit: "inch", majorDiameter: 0.875, tpi: 9 },
  { value: "7/8-14", label: "7/8-14 UNF", unit: "inch", majorDiameter: 0.875, tpi: 14 },
  { value: "1-14", label: "1-14 UNS", unit: "inch", majorDiameter: 1, tpi: 14 },
  { value: "1-1/8-7", label: "1-1/8-7 UNC", unit: "inch", majorDiameter: 1.125, tpi: 7 },
  { value: "1-1/8-12", label: "1-1/8-12 UNF", unit: "inch", majorDiameter: 1.125, tpi: 12 },
  { value: "1-1/4-7", label: "1-1/4-7 UNC", unit: "inch", majorDiameter: 1.25, tpi: 7 },
  { value: "1-1/4-12", label: "1-1/4-12 UNF", unit: "inch", majorDiameter: 1.25, tpi: 12 },
  { value: "1-1/2-6", label: "1-1/2-6 UNC", unit: "inch", majorDiameter: 1.5, tpi: 6 },
  { value: "1-1/2-12", label: "1-1/2-12 UNF", unit: "inch", majorDiameter: 1.5, tpi: 12 },
  { value: "M1.6x0.35", label: "M1.6 x 0.35", unit: "metric", majorDiameter: 1.6, pitch: 0.35 },
  { value: "M2x0.4", label: "M2 x 0.4", unit: "metric", majorDiameter: 2, pitch: 0.4 },
  { value: "M2.5x0.45", label: "M2.5 x 0.45", unit: "metric", majorDiameter: 2.5, pitch: 0.45 },
  { value: "M3x0.35", label: "M3 x 0.35 fine", unit: "metric", majorDiameter: 3, pitch: 0.35 },
  { value: "M4x0.5", label: "M4 x 0.5 fine", unit: "metric", majorDiameter: 4, pitch: 0.5 },
  { value: "M5x0.5", label: "M5 x 0.5 fine", unit: "metric", majorDiameter: 5, pitch: 0.5 },
  { value: "M6x0.75", label: "M6 x 0.75 fine", unit: "metric", majorDiameter: 6, pitch: 0.75 },
  { value: "M8x1", label: "M8 x 1.0 fine", unit: "metric", majorDiameter: 8, pitch: 1 },
  { value: "M10x1.25", label: "M10 x 1.25 fine", unit: "metric", majorDiameter: 10, pitch: 1.25 },
  { value: "M12x1.5", label: "M12 x 1.5 fine", unit: "metric", majorDiameter: 12, pitch: 1.5 },
  { value: "M14x2", label: "M14 x 2.0", unit: "metric", majorDiameter: 14, pitch: 2 },
  { value: "M14x1.5", label: "M14 x 1.5 fine", unit: "metric", majorDiameter: 14, pitch: 1.5 },
  { value: "M16x1.5", label: "M16 x 1.5 fine", unit: "metric", majorDiameter: 16, pitch: 1.5 },
  { value: "M18x2.5", label: "M18 x 2.5", unit: "metric", majorDiameter: 18, pitch: 2.5 },
  { value: "M18x1.5", label: "M18 x 1.5 fine", unit: "metric", majorDiameter: 18, pitch: 1.5 },
  { value: "M20x1.5", label: "M20 x 1.5 fine", unit: "metric", majorDiameter: 20, pitch: 1.5 },
  { value: "M24x3", label: "M24 x 3.0", unit: "metric", majorDiameter: 24, pitch: 3 },
  { value: "M24x2", label: "M24 x 2.0 fine", unit: "metric", majorDiameter: 24, pitch: 2 },
  { value: "M30x3.5", label: "M30 x 3.5", unit: "metric", majorDiameter: 30, pitch: 3.5 },
  { value: "M30x2", label: "M30 x 2.0 fine", unit: "metric", majorDiameter: 30, pitch: 2 },
  ...PIPE_THREAD_SIZE_OPTIONS,
];

export const calculateTapDrill = (params) => {
  const errors = {};
  const entryMode = params.entryMode || "preset";
  if (entryMode === "preset" && !params.threadSize) {
    errors.threadSize = "Thread size is required";
  }
  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const {
    threadSize,
    threadPercent = 75,
    customMajorDiameter,
    customPitch,
    customUnit = "inch",
    pitchMode = "tpi",
    threadSeries = "60-degree",
    threadName = "",
  } = params;
  const preset = THREAD_SIZE_OPTIONS.find((option) => option.value === threadSize);

  const unit = entryMode === "preset" ? preset?.unit : customUnit;
  const majorDiameter = entryMode === "preset"
    ? preset?.majorDiameter
    : parseDecimalOrFraction(customMajorDiameter);
  const customPitchValue = parseDecimalOrFraction(customPitch);
  const pitch = entryMode === "preset" && preset?.unit === "metric"
    ? preset.pitch
    : entryMode === "preset" && preset?.unit === "inch"
      ? 1 / preset.tpi
      : unit === "metric"
        ? customPitchValue
        : pitchMode === "pitch"
          ? customPitchValue
          : customPitchValue > 0
            ? 1 / customPitchValue
            : 0;

  if (!majorDiameter || majorDiameter <= 0) errors.majorDiameter = "Major diameter must be positive";
  if (!pitch || pitch <= 0) errors.pitch = unit === "metric" ? "Pitch in mm must be positive" : "Threads per inch or pitch must be positive";

  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  if (entryMode === "preset" && preset?.threadFamily === "pipe") {
    const pipeDrill = buildPipeTapDrillResult(preset, pitch);
    const pitchInch = unit === "metric" ? pitch * MM_TO_INCH : pitch;
    const majorInch = unit === "metric" ? majorDiameter * MM_TO_INCH : majorDiameter;
    const tapDrillSize = pipeDrill?.drillInch ? pipeDrill.drillInch.toFixed(4) : "";
    const tapDrillMetric = pipeDrill?.drillMetric ? pipeDrill.drillMetric.toFixed(3) : "";

    return {
      tapDrillSize,
      tapDrillMetric,
      threadPercent: "Pipe standard",
      basicTapDrill: pipeDrill?.display || "Verify standard",
      display: pipeDrill?.display || "Verify standard",
      conservativeDisplay: pipeDrill?.conservativeDisplay || "Verify standard",
      majorDiameter: unit === "metric" ? majorDiameter.toFixed(3) : majorDiameter.toFixed(4),
      pitch: unit === "metric" ? pitch.toFixed(4) : pitch.toFixed(5),
      pitchInch: pitchInch.toFixed(5),
      threadsPerInch: preset.tpi ? Number(preset.tpi).toFixed(3) : "",
      majorInch: majorInch.toFixed(4),
      threadLabel: preset.label,
      threadSeries: preset.threadSeries,
      threadFamily: preset.threadFamily,
      standard: preset.standard,
      taper: preset.taper,
      angle: preset.angle,
      handTightEngagement: preset.handTightEngagement ? preset.handTightEngagement.toFixed(3) : "",
      effectiveThreadLength: preset.effectiveThreadLength ? preset.effectiveThreadLength.toFixed(4) : "",
      unit,
      warnings: [
        "Pipe-thread tap drills are standard/reference values, not percentage-thread calculations.",
        "Verify pressure-service threads with the required pipe-thread gage, tap manufacturer data, and shop/customer standard.",
      ],
      notes: getPipeThreadNotes(preset),
      confidence: "Reference",
    };
  }

  const percentFactor = Math.max(50, Math.min(85, Number(threadPercent) || 75)) / 75;
  const baseDrill = majorDiameter - pitch;
  const adjustedDrill = majorDiameter - pitch * percentFactor;
  const drillSize = unit === "metric" ? adjustedDrill * MM_TO_INCH : adjustedDrill;
  const closest = findClosestDrillSize(drillSize);
  const conservativeClosest = findLargestDrillAtOrBelow(drillSize);
  const tapDrillMetric = unit === "metric" ? adjustedDrill : drillSize * INCH_TO_MM;
  const majorInch = unit === "metric" ? majorDiameter * MM_TO_INCH : majorDiameter;
  const pitchInch = unit === "metric" ? pitch * MM_TO_INCH : pitch;
  const threadLabel = preset?.label || threadName || `${unit === "metric" ? "M" : ""}${majorDiameter}${unit === "metric" ? ` x ${pitch}` : `-${Math.round(1 / pitch)}`}`;
  const warnings = [];

  if (Number(threadPercent) > 80) {
    warnings.push("High thread percentage increases tapping torque and breakage risk.");
  }

  if (threadSeries !== "60-degree") {
    warnings.push(`${threadSeries} thread selected. Result uses the standard major minus pitch tap drill approximation unless a company/thread standard says otherwise.`);
  }

  if (entryMode !== "preset") {
    warnings.push("Custom thread result is calculated from user-entered major diameter and pitch/TPI. Verify against the applicable thread standard, class, plating allowance, and tap manufacturer data.");
  }

  return {
    tapDrillSize: drillSize.toFixed(4),
    tapDrillMetric: tapDrillMetric.toFixed(3),
    threadPercent: Math.round(percentFactor * 75),
    basicTapDrill: unit === "metric" ? baseDrill.toFixed(3) : baseDrill.toFixed(4),
    display: `${closest.name} (${closest.size}")`,
    conservativeDisplay: `${conservativeClosest.name} (${conservativeClosest.size}")`,
    majorDiameter: unit === "metric" ? majorDiameter.toFixed(3) : majorDiameter.toFixed(4),
    pitch: unit === "metric" ? pitch.toFixed(4) : pitch.toFixed(5),
    pitchInch: pitchInch.toFixed(5),
    threadsPerInch: unit === "inch" ? (1 / pitch).toFixed(3) : "",
    majorInch: majorInch.toFixed(4),
    threadLabel,
    threadSeries,
    unit,
    warnings,
    confidence: entryMode === "preset" && threadSeries === "60-degree" ? "High" : "Estimate",
  };
};

//////////////////////////////////////////////////
// THREAD PITCH (LEGACY)
//////////////////////////////////////////////////

export const calculateThreadPitch = (params) => {
  const errors = validateInputs(params, ["majorDiameter", "threadsPerInch"]);
  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const { majorDiameter, threadsPerInch } = params;

  if (majorDiameter <= 0) errors.majorDiameter = "Major diameter must be positive";
  if (threadsPerInch <= 0) errors.threadsPerInch = "Threads per inch must be positive";

  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const pitch = 1 / threadsPerInch;
  const minorDiameter = majorDiameter - 1.08253175 * pitch;

  return {
    pitch: Math.round(pitch * 10000) / 10000,
    minorDiameter: Math.round(minorDiameter * 1000) / 1000,
    warnings: [],
    confidence: "High",
  };
};

//////////////////////////////////////////////////
// THREAD ADVANCED
//////////////////////////////////////////////////

export const THREAD_CLASS_OPTIONS = [
  { value: "1A", label: "1A - External Unified", threadType: "external" },
  { value: "2A", label: "2A - External Unified", threadType: "external" },
  { value: "3A", label: "3A - External Unified", threadType: "external" },
  { value: "1B", label: "1B - Internal Unified", threadType: "internal" },
  { value: "2B", label: "2B - Internal Unified", threadType: "internal" },
  { value: "3B", label: "3B - Internal Unified", threadType: "internal" },
  { value: "6g", label: "6g - External ISO metric", threadType: "external" },
  { value: "6H", label: "6H - Internal ISO metric", threadType: "internal" },
];

const getThreadClassInfo = (threadClass = "2A", threadType = "external", unit = "inch") => {
  const fallback = threadType === "internal" ? "2B" : "2A";
  const requested = THREAD_CLASS_OPTIONS.find((item) => item.value === threadClass);
  const compatible = requested?.threadType === threadType ? requested : null;
  const resolved = compatible || THREAD_CLASS_OPTIONS.find((item) => item.value === fallback);

  return {
    ...(resolved || THREAD_CLASS_OPTIONS[1]),
    unit,
  };
};

const calculatePitchDiameterClassLimits = ({
  pitchDiameter,
  threadType,
  threadClass,
  unit,
  pitchDiameterMin,
  pitchDiameterMax,
}) => {
  const classInfo = getThreadClassInfo(threadClass, threadType, unit);
  const minimum = Number(pitchDiameterMin);
  const maximum = Number(pitchDiameterMax);
  const hasLimits =
    Number.isFinite(minimum) &&
    Number.isFinite(maximum) &&
    minimum > 0 &&
    maximum >= minimum;
  return {
    classInfo,
    allowance: hasLimits
      ? Math.max(0, threadType === "external" ? pitchDiameter - maximum : minimum - pitchDiameter)
      : null,
    tolerance: hasLimits ? maximum - minimum : null,
    pitchDiameterMin: hasLimits ? minimum : null,
    pitchDiameterMax: hasLimits ? maximum : null,
    note: hasLimits
      ? `${classInfo.value} limits were supplied by the user and are used directly for inspection calculations.`
      : `${classInfo.value} identifies the required fit class. Enter pitch-diameter limits from the controlling ASME B1.1, ISO 965 table, drawing, or certified thread data; ManuCalc does not invent class tolerances.`,
  };
};

const calculateThreadWireData = ({
  pitchDiameter,
  pitch,
  angle,
  unit,
  threadType,
  threadClass,
  pitchDiameterMin,
  pitchDiameterMax,
}) => {
  const angleRadians = (Number(angle) * Math.PI) / 180;
  const halfAngleRadians = angleRadians / 2;
  const bestWire = pitch / (2 * Math.cos(halfAngleRadians));
  const exactConstant = pitch / (2 * Math.tan(halfAngleRadians));
  const measurementOverWires = pitchDiameter + (3 * bestWire) - exactConstant;
  const classLimits = calculatePitchDiameterClassLimits({
    pitchDiameter,
    pitch,
    threadType,
    threadClass,
    unit,
    pitchDiameterMin,
    pitchDiameterMax,
  });
  const measurementOverWiresMin = classLimits.pitchDiameterMin === null
    ? null
    : classLimits.pitchDiameterMin + (3 * bestWire) - exactConstant;
  const measurementOverWiresMax = classLimits.pitchDiameterMax === null
    ? null
    : classLimits.pitchDiameterMax + (3 * bestWire) - exactConstant;

  return {
    bestWire,
    measurementOverWires,
    measurementOverWiresMin,
    measurementOverWiresMax,
    pitchDiameterMin: classLimits.pitchDiameterMin,
    pitchDiameterMax: classLimits.pitchDiameterMax,
    classAllowance: classLimits.allowance,
    classTolerance: classLimits.tolerance,
    classLabel: classLimits.classInfo.label,
    classNote: classLimits.note,
  };
};

const calculatePipeThreadAdvanced = ({ preset, params, pitch }) => {
  const unit = preset.unit;
  const starts = Number(params.starts) || 1;
  const lead = pitch * starts;
  const pipeDrill = buildPipeTapDrillResult(preset, pitch);
  const majorDiameter = Number(params.majorDiameter);
  const majorDiameterInch = toInches(majorDiameter, unit);
  const majorDiameterMetric = toMillimeters(majorDiameter, unit);
  const pitchInch = toInches(pitch, unit);
  const pitchMetric = toMillimeters(pitch, unit);
  const leadInch = toInches(lead, unit);
  const leadMetric = toMillimeters(lead, unit);

  return {
    unit,
    threadType: params.threadType || "internal",
    threadClass: preset.threadSeries,
    classLabel: preset.standard,
    threadFamily: "pipe",
    threadLabel: preset.label,
    standard: preset.standard,
    taper: preset.taper,
    angle: preset.angle,
    majorDiameter: `${format4(majorDiameterInch)} in / ${format3(majorDiameterMetric)} mm`,
    pitch: `${format4(pitchMetric)} mm / ${format5(pitchInch)} in`,
    tpi: preset.tpi ? Number(preset.tpi).toFixed(3) : "",
    lead: `${format4(leadInch)} in / ${format3(leadMetric)} mm`,
    pitchDiameter: "Use pipe-thread standard gage dimensions",
    pitchDiameterMin: "Use pipe-thread gage limits",
    pitchDiameterMax: "Use pipe-thread gage limits",
    minorDiameter: "Controlled by pipe-thread form and gaging standard",
    threadDepth: preset.threadSeries === "NPT" ? "Tapered 1:16; verify with L1/L2 gage" : "Verify with ISO/BS pipe-thread standard",
    bestWireSize: "Not recommended for pipe-thread acceptance",
    measurementOverWires: "Use pipe-thread plug/ring gages",
    measurementOverWiresMin: "N/A",
    measurementOverWiresMax: "N/A",
    tapDrill: pipeDrill?.display || "Verify standard",
    tapDrillInch: pipeDrill?.drillInch ? format4(pipeDrill.drillInch) : "",
    tapDrillMetric: pipeDrill?.drillMetric ? format3(pipeDrill.drillMetric) : "",
    handTightEngagement: preset.handTightEngagement ? `${format3(preset.handTightEngagement)} in` : "",
    effectiveThreadLength: preset.effectiveThreadLength ? `${format4(preset.effectiveThreadLength)} in` : "",
    warnings: [
      "Pipe threads are not accepted by Unified/metric class limits or three-wire measurement.",
      "Use the correct NPT/NPTF/BSPP/BSPT gage and the controlling drawing, pressure, and sealing requirements.",
    ],
    notes: getPipeThreadNotes(preset),
    confidence: "Reference",
  };
};

export const calculateThreadAdvanced = (params) => {
  const errors = validateInputs(params, ["majorDiameter"]);
  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const {
    unit = "inch",
    threadType = "external",
    threadClass,
    majorDiameter,
    starts = 1,
    angle = 60,
  } = params;

  if (majorDiameter <= 0) {
    errors.majorDiameter = "Major diameter must be greater than zero";
  }

  if (!starts || starts <= 0) {
    errors.starts = "Starts must be greater than zero";
  }

  if (!angle || angle <= 0 || angle >= 180) {
    errors.angle = "Thread angle must be between 0 and 180 degrees";
  }

  const pitch = resolveThreadPitch(params, errors);

  const suppliedPitchDiameterMin = Number(params.pitchDiameterMin);
  const suppliedPitchDiameterMax = Number(params.pitchDiameterMax);
  const hasPitchDiameterMin = params.pitchDiameterMin !== "" && params.pitchDiameterMin !== undefined;
  const hasPitchDiameterMax = params.pitchDiameterMax !== "" && params.pitchDiameterMax !== undefined;
  if (hasPitchDiameterMin !== hasPitchDiameterMax) {
    errors.pitchDiameterLimits = "Enter both pitch-diameter limits or leave both empty.";
  } else if (
    hasPitchDiameterMin &&
    (
      !Number.isFinite(suppliedPitchDiameterMin) ||
      !Number.isFinite(suppliedPitchDiameterMax) ||
      suppliedPitchDiameterMin <= 0 ||
      suppliedPitchDiameterMax < suppliedPitchDiameterMin
    )
  ) {
    errors.pitchDiameterLimits = "Pitch-diameter limits must be positive and maximum must be at least minimum.";
  }

  if (Object.keys(errors).length > 0 || !pitch) {
    return { errors, warnings: [], confidence: "Invalid" };
  }

  const pipePreset = params.threadFamily === "pipe"
    ? THREAD_SIZE_OPTIONS.find((option) => option.value === params.threadStandard)
    : null;

  if (pipePreset) {
    return calculatePipeThreadAdvanced({ preset: pipePreset, params, pitch });
  }

  const warnings = [];
  const notes = [];

  const angleRadians = (Number(angle) * Math.PI) / 180;
  const halfAngleRadians = angleRadians / 2;

  const fundamentalHeight = pitch / (2 * Math.tan(halfAngleRadians));
  const pitchDiameter = majorDiameter - 0.75 * fundamentalHeight;

  const externalMinorDiameter = majorDiameter - (17 / 12) * fundamentalHeight;
  const internalMinorDiameter = majorDiameter - 1.25 * fundamentalHeight;

  const minorDiameter =
    threadType === "internal" ? internalMinorDiameter : externalMinorDiameter;

  const threadDepth =
    threadType === "internal"
      ? 0.625 * fundamentalHeight
      : (17 / 24) * fundamentalHeight;

  const tpi = unit === "metric" ? 25.4 / pitch : 1 / pitch;
  const lead = pitch * Number(starts);

  const tapDrillValue = threadType === "internal" ? majorDiameter - pitch : majorDiameter - pitch;
  const tapDrill = buildTapDrillDisplay(tapDrillValue, unit);

  const majorDiameterInch = toInches(majorDiameter, unit);
  const majorDiameterMetric = toMillimeters(majorDiameter, unit);
  const pitchInch = toInches(pitch, unit);
  const pitchMetric = toMillimeters(pitch, unit);
  const leadInch = toInches(lead, unit);
  const leadMetric = toMillimeters(lead, unit);
  const pitchDiameterInch = toInches(pitchDiameter, unit);
  const pitchDiameterMetric = toMillimeters(pitchDiameter, unit);
  const minorDiameterInch = toInches(minorDiameter, unit);
  const minorDiameterMetric = toMillimeters(minorDiameter, unit);
  const threadDepthInch = toInches(threadDepth, unit);
  const threadDepthMetric = toMillimeters(threadDepth, unit);
  const resolvedThreadClass = threadClass || (threadType === "internal" ? "2B" : "2A");
  const wireData = calculateThreadWireData({
    pitchDiameter,
    pitch,
    angle,
    unit,
    threadType,
    threadClass: resolvedThreadClass,
    pitchDiameterMin: params.pitchDiameterMin,
    pitchDiameterMax: params.pitchDiameterMax,
  });

  if (Number(angle) !== 60) {
    warnings.push("Most standard Unified and ISO metric threads use a 60° angle.");
    notes.push("Non-60° thread forms are supported mathematically here, but many standard tap drill and class-fit assumptions are based on 60° forms.");
  }

  if (Number(starts) > 1) {
    notes.push("Multi-start lead is pitch × starts. TPI still reflects individual thread pitch spacing.");
  }

  if (unit === "metric") {
    notes.push("Metric tap drill is approximated as major diameter minus pitch.");
  } else {
    notes.push("Unified tap drill is approximated as major diameter minus pitch.");
  }

  if (threadType === "external") {
    notes.push("Tap drill output is shown as the mating internal thread estimate for this pitch and diameter.");
    notes.push("Three-wire measurement is for external threads. For internal threads, use thread plug gages or an internal thread measuring method.");
  } else {
    notes.push("Minor diameter shown is the internal thread minor diameter.");
    warnings.push("Measurement-over-wires is primarily an external thread inspection method. Internal thread class limits are shown for planning and gage selection.");
  }

  notes.push(wireData.classNote);

  if (minorDiameter <= 0 || pitchDiameter <= 0) {
    warnings.push("Computed diameters are non-physical. Check major diameter, pitch, and angle values.");
  }

  return {
    majorDiameter: roundByUnit(majorDiameter, unit),
    pitch: roundByUnit(pitch, unit),
    tpi: format3(tpi),
    lead: roundByUnit(lead, unit),
    angle: Number(angle),
    starts: Number(starts),

    pitchDiameter: roundByUnit(pitchDiameter, unit),
    minorDiameter: roundByUnit(minorDiameter, unit),
    threadDepth: roundByUnit(threadDepth, unit),
    threadClass: resolvedThreadClass,
    classLabel: wireData.classLabel,
    pitchDiameterMin: wireData.pitchDiameterMin === null
      ? "Enter standard limit"
      : roundByUnit(wireData.pitchDiameterMin, unit),
    pitchDiameterMax: wireData.pitchDiameterMax === null
      ? "Enter standard limit"
      : roundByUnit(wireData.pitchDiameterMax, unit),
    classAllowance: wireData.classAllowance === null
      ? "Requires standard limits"
      : roundByUnit(wireData.classAllowance, unit),
    classTolerance: wireData.classTolerance === null
      ? "Requires standard limits"
      : roundByUnit(wireData.classTolerance, unit),
    bestWireSize: roundByUnit(wireData.bestWire, unit),
    measurementOverWires: roundByUnit(wireData.measurementOverWires, unit),
    measurementOverWiresMin: wireData.measurementOverWiresMin === null
      ? "Enter standard limit"
      : roundByUnit(wireData.measurementOverWiresMin, unit),
    measurementOverWiresMax: wireData.measurementOverWiresMax === null
      ? "Enter standard limit"
      : roundByUnit(wireData.measurementOverWiresMax, unit),

    majorDiameterInch: format4(majorDiameterInch),
    majorDiameterMetric: format3(majorDiameterMetric),
    pitchInch: format4(pitchInch),
    pitchMetric: format3(pitchMetric),
    leadInch: format4(leadInch),
    leadMetric: format3(leadMetric),
    pitchDiameterInch: format4(pitchDiameterInch),
    pitchDiameterMetric: format3(pitchDiameterMetric),
    minorDiameterInch: format4(minorDiameterInch),
    minorDiameterMetric: format3(minorDiameterMetric),
    threadDepthInch: format4(threadDepthInch),
    threadDepthMetric: format3(threadDepthMetric),
    bestWireSizeInch: format4(toInches(wireData.bestWire, unit)),
    bestWireSizeMetric: format3(toMillimeters(wireData.bestWire, unit)),
    measurementOverWiresInch: format4(toInches(wireData.measurementOverWires, unit)),
    measurementOverWiresMetric: format3(toMillimeters(wireData.measurementOverWires, unit)),

    externalMinorDiameter:
      threadType === "external" ? roundByUnit(externalMinorDiameter, unit) : roundByUnit(externalMinorDiameter, unit),
    internalMinorDiameter:
      threadType === "internal" ? roundByUnit(internalMinorDiameter, unit) : roundByUnit(internalMinorDiameter, unit),

    fundamentalHeight: roundByUnit(fundamentalHeight, unit),
    tapDrill,

    warnings,
    notes,
    confidence: warnings.length === 0 ? "High" : "Medium",
  };
};

//////////////////////////////////////////////////
// HOLE CLEARANCE
//////////////////////////////////////////////////

export const calculateHoleClearance = (params) => {
  const {
    standard = "asme_inch",
    mode = HOLE_CALCULATION_MODES.standard,
    process = HOLE_MAKING_PROCESSES.drill,
    condition = HOLE_MAKING_CONDITIONS.normal,
  } = params;

  const requiredFields =
    mode === HOLE_CALCULATION_MODES.custom
      ? ["customHoleSize"]
      : ["boltSize", "fit"];

  const errors = validateInputs(params, requiredFields);
  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const targetHoleSize = getTargetHoleSize(params, errors);
  if (Object.keys(errors).length > 0 || !targetHoleSize) {
    return { errors, confidence: "Invalid" };
  }

  let recommendation;

  switch (process) {
    case HOLE_MAKING_PROCESSES.drill:
      recommendation = buildDrillOnlyRecommendation(targetHoleSize, condition);
      break;
    case HOLE_MAKING_PROCESSES.drill_ream:
      recommendation = buildReamRecommendation(targetHoleSize, condition);
      break;
    case HOLE_MAKING_PROCESSES.drill_bore:
      recommendation = buildBoreRecommendation(targetHoleSize, condition, process);
      break;
    case HOLE_MAKING_PROCESSES.bore_only:
      recommendation = buildBoreRecommendation(targetHoleSize, condition, process);
      break;
    default:
      return {
        errors: { process: "Invalid process type" },
        warnings: [],
        confidence: "Invalid",
      };
  }

  const warnings = [];
  const processNotes = getProcessNotes(process, condition);

  if (
    process === HOLE_MAKING_PROCESSES.drill &&
    recommendation.expectedHoleMax > targetHoleSize
  ) {
    warnings.push("Drill-only process may produce an actual hole larger than the nominal target.");
  }

  if (
    process === HOLE_MAKING_PROCESSES.drill_ream &&
    recommendation.prepHoleMax >= targetHoleSize
  ) {
    warnings.push("Prep hole may be too large for reliable reaming if setup quality is poor.");
  }

  if (
    condition === HOLE_MAKING_CONDITIONS.high_runout &&
    process === HOLE_MAKING_PROCESSES.drill
  ) {
    warnings.push("High runout makes drill-only sizing less predictable.");
  }

  const recommendedDrillSizeName = recommendation.recommendedDrill
    ? recommendation.recommendedDrill.name
    : null;
  const recommendedDrillSizeDecimal = recommendation.recommendedDrill
    ? format4(recommendation.recommendedDrill.size)
    : null;

  return {
    standard,
    mode,
    process,
    condition,
    targetHoleSize: format4(targetHoleSize),
    targetHoleMetric: format3(targetHoleSize * INCH_TO_MM),
    holeSize: format4(targetHoleSize),
    recommendedDrillSizeName,
    recommendedDrillSizeDecimal,
    recommendedDrillMetric: recommendedDrillSizeDecimal != null ? format3(recommendedDrillSizeDecimal * INCH_TO_MM) : null,
    drillSizeName: recommendedDrillSizeName,
    drillSizeDecimal: recommendedDrillSizeDecimal,
    expectedHoleMin: recommendation.expectedHoleMin,
    expectedHoleMax: recommendation.expectedHoleMax,
    expectedHoleMinMetric: recommendation.expectedHoleMin != null ? format3(recommendation.expectedHoleMin * INCH_TO_MM) : null,
    expectedHoleMaxMetric: recommendation.expectedHoleMax != null ? format3(recommendation.expectedHoleMax * INCH_TO_MM) : null,
    prepHoleMin: recommendation.prepHoleMin,
    prepHoleMax: recommendation.prepHoleMax,
    prepHoleMinMetric: recommendation.prepHoleMin != null ? format3(recommendation.prepHoleMin * INCH_TO_MM) : null,
    prepHoleMaxMetric: recommendation.prepHoleMax != null ? format3(recommendation.prepHoleMax * INCH_TO_MM) : null,
    allowanceMin: recommendation.allowanceMin,
    allowanceMax: recommendation.allowanceMax,
    allowanceMinMetric: recommendation.allowanceMin != null ? format3(recommendation.allowanceMin * INCH_TO_MM) : null,
    allowanceMaxMetric: recommendation.allowanceMax != null ? format3(recommendation.allowanceMax * INCH_TO_MM) : null,
    processNotes,
    warnings,
    confidence: warnings.length === 0 ? "High" : "Medium",
  };
};

// Backward-compatible alias
export const calculateHoleSizing = (params) => {
  return calculateHoleClearance(params);
};

//////////////////////////////////////////////////
// G-CODE STARTER PROGRAM
//////////////////////////////////////////////////

export const CNC_MACHINE_PROFILES = [
  { value: "haas_vf2", brand: "Haas", model: "VF-2", type: "mill", control: "Haas NGC / Classic Haas", yearMin: 1996, toolChange: "m06", home: "G53 G49 Z0" },
  { value: "haas_vm2", brand: "Haas", model: "VM-2", type: "mill", control: "Haas NGC / Classic Haas", yearMin: 2003, toolChange: "m06", home: "G53 G49 Z0" },
  { value: "haas_mini_mill", brand: "Haas", model: "Mini Mill", type: "mill", control: "Haas NGC / Classic Haas", yearMin: 2000, toolChange: "m06", home: "G53 G49 Z0" },
  { value: "haas_umc500", brand: "Haas", model: "UMC-500", type: "mill", control: "Haas NGC 5-axis", yearMin: 2018, toolChange: "m06", home: "G53 G49 Z0" },
  { value: "haas_st20", brand: "Haas", model: "ST-20", type: "lathe", control: "Haas Lathe NGC / Classic Haas", yearMin: 2010, toolChange: "turret", home: "G53 X0 Z0" },
  { value: "haas_tl2", brand: "Haas", model: "TL-2 Toolroom Lathe", type: "lathe", control: "Haas Toolroom Lathe", yearMin: 2004, toolChange: "manual_lathe", home: "G53 X0 Z0" },
  { value: "haas_tl1", brand: "Haas", model: "TL-1 Toolroom Lathe", type: "lathe", control: "Haas Toolroom Lathe", yearMin: 2004, toolChange: "manual_lathe", home: "G53 X0 Z0" },
  { value: "mazak_vcn", brand: "Mazak", model: "VCN Series", type: "mill", control: "Mazatrol EIA/ISO", yearMin: 2000, toolChange: "m06", home: "G53 Z0" },
  { value: "mazak_quick_turn", brand: "Mazak", model: "Quick Turn Series", type: "lathe", control: "Mazatrol EIA/ISO", yearMin: 2000, toolChange: "turret", home: "G28 U0 W0" },
  { value: "okuma_genos_m560", brand: "Okuma", model: "GENOS M560", type: "mill", control: "OSP", yearMin: 2011, toolChange: "m06", home: "G15 H0 Z0" },
  { value: "okuma_lb3000", brand: "Okuma", model: "LB3000 EX", type: "lathe", control: "OSP", yearMin: 2008, toolChange: "turret", home: "G00 X20. Z20." },
  { value: "dn_dnm", brand: "DN Solutions / Doosan", model: "DNM Series", type: "mill", control: "Fanuc-style", yearMin: 2008, toolChange: "m06", home: "G91 G28 Z0" },
  { value: "dn_puma", brand: "DN Solutions / Doosan", model: "Puma Series", type: "lathe", control: "Fanuc-style", yearMin: 2000, toolChange: "turret", home: "G28 U0 W0" },
  { value: "hurco_vmx", brand: "Hurco", model: "VMX Series", type: "mill", control: "WinMax NC", yearMin: 2000, toolChange: "m06", home: "G53 Z0" },
  { value: "tormach_pcnc", brand: "Tormach", model: "PCNC Series", type: "mill", control: "PathPilot", yearMin: 2014, toolChange: "m06", home: "G53 G0 Z0" },
  { value: "fadal_vmc", brand: "Fadal", model: "VMC Series", type: "mill", control: "Fadal / Fanuc-style", yearMin: 1988, toolChange: "m06", home: "G53 Z0" },
  { value: "brother_speedio", brand: "Brother", model: "Speedio", type: "mill", control: "Brother CNC-C", yearMin: 2013, toolChange: "m06", home: "G91 G28 Z0" },
  { value: "makino_ps", brand: "Makino", model: "PS / F Series", type: "mill", control: "Fanuc Pro / Professional", yearMin: 2008, toolChange: "m06", home: "G91 G28 Z0" },
  { value: "fanuc_generic_mill", brand: "Generic", model: "Fanuc-Style 3-Axis Mill", type: "mill", control: "Fanuc ISO", yearMin: 1980, toolChange: "m06", home: "G91 G28 Z0" },
  { value: "fanuc_generic_lathe", brand: "Generic", model: "Fanuc-Style 2-Axis Lathe", type: "lathe", control: "Fanuc ISO", yearMin: 1980, toolChange: "turret", home: "G28 U0 W0" },
];

export const CNC_OPERATION_OPTIONS = [
  { value: "face_mill", label: "Face Mill Rectangular Stock", type: "mill" },
  { value: "rectangular_profile", label: "Mill Outside Rectangular Profile", type: "mill" },
  { value: "pocket_rectangle", label: "Rough Rectangular Pocket", type: "mill" },
  { value: "slot_mill", label: "Mill Centerline Slot", type: "mill" },
  { value: "chamfer_mill", label: "Chamfer Outside Rectangle", type: "mill" },
  { value: "spot_drill_pattern", label: "Spot Drill Hole Pattern", type: "mill" },
  { value: "drill_pattern", label: "Drill Hole Pattern", type: "mill" },
  { value: "peck_drill_pattern", label: "Peck Drill Hole Pattern", type: "mill" },
  { value: "tap_pattern", label: "Rigid Tap Hole Pattern", type: "mill" },
  { value: "face_turn", label: "Lathe Face Stock", type: "lathe" },
  { value: "od_turn", label: "OD Turn / Reduce Diameter", type: "lathe" },
  { value: "od_finish", label: "OD Finish Pass", type: "lathe" },
  { value: "center_drill_lathe", label: "Center Drill on Spindle Centerline", type: "lathe" },
  { value: "drill_lathe", label: "Drill on Spindle Centerline", type: "lathe" },
  { value: "bore_lathe", label: "Bore ID", type: "lathe" },
  { value: "groove_od", label: "OD Groove", type: "lathe" },
  { value: "chamfer_od", label: "OD Front Chamfer", type: "lathe" },
  { value: "thread_od", label: "OD Threading Starter", type: "lathe" },
  { value: "part_off", label: "Part Off", type: "lathe" },
];

const g = (value) => Number(value || 0).toFixed(4).replace(/\.?0+$/, "");

const getMachineOperation = (operation, type) =>
  CNC_OPERATION_OPTIONS.find((item) => item.value === operation && item.type === type) ||
  CNC_OPERATION_OPTIONS.find((item) => item.type === type);

const pushToolChange = (program, machine, toolNumber) => {
  const tool = Math.max(1, Math.round(Number(toolNumber || 1)));
  if (machine.toolChange === "manual_lathe") {
    program.push(`(LOAD TOOL ${tool} AND VERIFY X/Z OFFSETS)`);
    program.push("M00");
    return;
  }
  if (machine.toolChange === "turret") {
    program.push(`T${String(tool).padStart(2, "0")}${String(tool).padStart(2, "0")}`);
    return;
  }
  program.push(`T${tool} M06`);
};

const buildMillGCode = ({ program, params, machine, stockX, stockY, depth, safeZ, toolDiameter, rpm, feed }) => {
  const plane = params.planeSelection || "G17";
  const distanceMode = params.distanceMode || "G90";
  const workOffset = params.workOffset || "G54";
  const coolantCode = params.coolantCode || "M08";
  const retractPlane = Number(params.retractPlane || 0.05);
  const peckDepth = Number(params.peckDepth || Math.max(depth / 3, 0.02));
  const importedCoordinates = Array.isArray(params.importedCoordinates) ? params.importedCoordinates : [];
  program.push(`${params.safeStartBlock || "G20"} ${plane} G40 G49 G80 ${distanceMode}`);
  pushToolChange(program, machine, params.toolNumber);
  program.push(`S${rpm} M03`);
  program.push(workOffset);
  program.push(`G00 ${distanceMode} X0 Y0`);
  program.push(`G43 H${Math.max(1, Math.round(Number(params.toolNumber || 1)))} Z${g(safeZ)}`);
  if (coolantCode !== "off") program.push(coolantCode);

  if (params.operation === "face_mill") {
    const step = Math.max(toolDiameter * 0.65, 0.01);
    program.push("(FACE TOP OF STOCK WITH PARALLEL PASSES)");
    program.push(`G00 X${g(-toolDiameter)} Y${g(-toolDiameter / 2)} Z${g(safeZ)}`);
    program.push(`G01 Z-${g(depth)} F${g(feed * 0.35)}`);
    for (let y = -toolDiameter / 2; y <= stockY + toolDiameter / 2; y += step) {
      program.push(`G01 X${g(stockX + toolDiameter)} Y${g(y)} F${g(feed)}`);
      y += step;
      if (y <= stockY + toolDiameter / 2) program.push(`G01 X${g(-toolDiameter)} Y${g(y)} F${g(feed)}`);
    }
  } else if (params.operation === "rectangular_profile") {
    const offset = toolDiameter / 2;
    program.push("(PROFILE OUTSIDE RECTANGLE - COMPENSATION NOT USED)");
    program.push(`G00 X${g(-offset)} Y${g(-offset)} Z${g(safeZ)}`);
    program.push(`G01 Z-${g(depth)} F${g(feed * 0.35)}`);
    program.push(`G01 X${g(stockX + offset)} F${g(feed)}`);
    program.push(`G01 Y${g(stockY + offset)}`);
    program.push(`G01 X${g(-offset)}`);
    program.push(`G01 Y${g(-offset)}`);
  } else if (params.operation === "pocket_rectangle") {
    program.push("(ROUGH RECTANGULAR POCKET - SIMPLE OFFSET PASSES)");
    program.push(`G00 X${g(toolDiameter)} Y${g(toolDiameter)} Z${g(safeZ)}`);
    program.push(`G01 Z-${g(depth)} F${g(feed * 0.35)}`);
    program.push(`G01 X${g(stockX - toolDiameter)} F${g(feed)}`);
    program.push(`G01 Y${g(stockY - toolDiameter)}`);
    program.push(`G01 X${g(toolDiameter)}`);
    program.push(`G01 Y${g(toolDiameter)}`);
  } else if (params.operation === "slot_mill") {
    program.push("(MILL CENTERLINE SLOT ALONG X)");
    program.push(`G00 X0 Y${g(stockY / 2)} Z${g(safeZ)}`);
    program.push(`G01 Z-${g(depth)} F${g(feed * 0.35)}`);
    program.push(`G01 X${g(stockX)} F${g(feed)}`);
  } else if (params.operation === "chamfer_mill") {
    const offset = Math.max(toolDiameter / 2, 0.001);
    program.push("(CHAMFER OUTSIDE RECTANGLE - VERIFY CHAMFER TOOL DIAMETER/OFFSET)");
    program.push(`G00 X${g(-offset)} Y${g(-offset)} Z${g(safeZ)}`);
    program.push(`G01 Z-${g(depth)} F${g(feed * 0.35)}`);
    program.push(`G01 X${g(stockX + offset)} F${g(feed)}`);
    program.push(`G01 Y${g(stockY + offset)}`);
    program.push(`G01 X${g(-offset)}`);
    program.push(`G01 Y${g(-offset)}`);
  } else {
    const holeCount = Math.max(1, Number(params.holeCount || 4));
    const cycle = params.operation === "peck_drill_pattern" ? "G83" : params.operation === "tap_pattern" ? "G84" : "G81";
    const opLabel = params.operation === "spot_drill_pattern" ? "SPOT DRILL" : params.operation === "tap_pattern" ? "TAP" : "DRILL";
    const holeLocations = importedCoordinates.length
      ? importedCoordinates
      : Array.from({ length: holeCount }, (_, i) => ({
          x: holeCount === 1 ? stockX / 2 : (stockX / (holeCount + 1)) * (i + 1),
          y: stockY / 2,
        }));
    program.push(importedCoordinates.length ? `(${opLabel} IMPORTED BOLT PATTERN COORDINATES)` : `(${opLabel} EVENLY SPACED HOLES ALONG X CENTERLINE)`);
    for (let i = 0; i < holeLocations.length; i += 1) {
      const x = Number(holeLocations[i].x);
      const y = Number(holeLocations[i].y);
      program.push(`G00 X${g(x)} Y${g(y)} Z${g(safeZ)}`);
      program.push(`${cycle} Z-${g(depth)} R${g(retractPlane)} ${cycle === "G83" ? `Q${g(peckDepth)} ` : ""}F${g(feed)}`);
    }
    program.push("G80");
  }

  program.push(`G00 Z${g(safeZ)}`);
  if (coolantCode !== "off") program.push("M09");
  program.push(machine.home);
  program.push("M30");
};

const buildLatheGCode = ({ program, params, machine, stockX, stockZ, depth, safeZ, rpm, feed }) => {
  const startDiameter = Number(params.stockDiameter || stockX);
  const finishDiameter = Math.max(0.01, startDiameter - depth * 2);
  const zEnd = -Math.abs(stockZ);
  const workOffset = params.workOffset || "G54";
  const coolantCode = params.coolantCode || "M08";
  program.push(`${params.safeStartBlock || "G20"} G18 G40 G80 G99`);
  pushToolChange(program, machine, params.toolNumber);
  program.push(`G97 S${rpm} M03`);
  program.push(workOffset);
  if (coolantCode !== "off") program.push(coolantCode);

  if (params.operation === "face_turn") {
    program.push("(FACE STOCK - X VALUES ARE DIAMETER)");
    program.push(`G00 X${g(startDiameter + safeZ)} Z${g(safeZ)}`);
    program.push(`G01 Z0 F${g(feed)}`);
    program.push(`G01 X-${g(0.02)} F${g(feed)}`);
  } else if (params.operation === "od_turn" || params.operation === "od_finish") {
    program.push("(OD TURN - X VALUES ARE DIAMETER)");
    program.push(`G00 X${g(startDiameter + safeZ)} Z${g(0.1)}`);
    program.push(`G01 X${g(finishDiameter)} F${g(feed * 0.5)}`);
    program.push(`G01 Z${g(zEnd)} F${g(feed)}`);
    program.push(`G00 X${g(startDiameter + safeZ)}`);
  } else if (params.operation === "center_drill_lathe" || params.operation === "drill_lathe") {
    const cycle = params.operation === "drill_lathe" ? "G81" : "G81";
    program.push("(DRILL ON SPINDLE CENTERLINE)");
    program.push(`G00 X0 Z${g(0.1)}`);
    program.push(`${cycle} Z-${g(Math.abs(depth))} R${g(0.05)} F${g(feed)}`);
    program.push("G80");
  } else if (params.operation === "bore_lathe") {
    program.push("(BORE ID - VERIFY BORING BAR CLEARANCE)");
    program.push(`G00 X${g(Math.max(0.05, depth))} Z${g(0.1)}`);
    program.push(`G01 Z${g(zEnd)} F${g(feed)}`);
    program.push(`G01 X${g(Math.max(0.05, depth * 2))} F${g(feed * 0.5)}`);
  } else if (params.operation === "groove_od") {
    program.push("(OD GROOVE)");
    program.push(`G00 X${g(startDiameter + safeZ)} Z-${g(Math.abs(depth))}`);
    program.push(`G01 X${g(finishDiameter)} F${g(feed)}`);
  } else if (params.operation === "chamfer_od") {
    const chamfer = Math.abs(depth);
    program.push("(OD FRONT CHAMFER - X VALUES ARE DIAMETER)");
    program.push(`G00 X${g(startDiameter + safeZ)} Z${g(0.05)}`);
    program.push(`G01 Z0 F${g(feed)}`);
    program.push(`G01 X${g(startDiameter - chamfer * 2)} Z-${g(chamfer)} F${g(feed)}`);
    program.push(`G00 X${g(startDiameter + safeZ)}`);
  } else if (params.operation === "thread_od") {
    program.push("(OD THREADING STARTER - VERIFY PITCH, PASSES, AND INSERT)");
    program.push(`G00 X${g(startDiameter + safeZ)} Z${g(0.1)}`);
    program.push(`G76 X${g(finishDiameter)} Z${g(zEnd)} K${g(depth)} D${g(depth / 4)} F${g(params.threadPitch || 0.05)}`);
  } else if (params.operation === "part_off") {
    program.push("(PART OFF - VERIFY PARTING TOOL WIDTH AND CATCHER)");
    program.push(`G00 X${g(startDiameter + safeZ)} Z${g(zEnd)}`);
    program.push(`G01 X-${g(0.02)} F${g(feed)}`);
  }

  if (coolantCode !== "off") program.push("M09");
  program.push(machine.home);
  program.push("M30");
};

export const calculateGCodeProgram = (params) => {
  const machine = CNC_MACHINE_PROFILES.find((item) => item.value === params.machineProfile);
  const isLathe = machine?.type === "lathe";
  const errors = validateInputs(params, [
    "machineProfile",
    "machineYear",
    "operation",
    "stockX",
    ...(isLathe ? [] : ["stockY", "toolDiameter"]),
    "stockZ",
    "spindleRPM",
    "feedRate",
  ]);
  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  if (!machine) errors.machineProfile = "Select a supported machine profile";
  const operation = machine ? getMachineOperation(params.operation, machine.type) : null;
  if (!operation) errors.operation = "Select an operation supported by this machine type";

  const stockX = Number(params.stockX);
  const stockY = Number(params.stockY);
  const stockZ = Number(params.stockZ);
  const depth = Math.abs(Number(params.depth || 0.05));
  const safeZ = Number(params.safeZ || 0.25);
  const toolDiameter = Number(params.toolDiameter);
  const rpm = Math.round(Number(params.spindleRPM));
  const feed = Number(params.feedRate);
  const year = Number(params.machineYear);

  if (stockX <= 0) errors.stockX = "Stock X must be positive";
  if (!isLathe && stockY <= 0) errors.stockY = "Stock Y must be positive";
  if (stockZ <= 0) errors.stockZ = "Stock Z must be positive";
  if (!isLathe && toolDiameter <= 0) errors.toolDiameter = "Tool diameter must be positive";
  if (rpm <= 0) errors.spindleRPM = "RPM must be positive";
  if (feed <= 0) errors.feedRate = "Feed rate must be positive";
  if (Number(params.shopMachineMaxRPM) > 0 && rpm > Number(params.shopMachineMaxRPM)) {
    errors.spindleRPM = `Programmed RPM exceeds linked shop machine limit of ${Number(params.shopMachineMaxRPM)} RPM`;
  }
  if (machine && year < machine.yearMin) {
    errors.machineYear = `${machine.brand} ${machine.model} profile starts at ${machine.yearMin}`;
  }

  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const program = [];
  program.push(`(MANUCALC STARTER PROGRAM - VERIFY BEFORE RUNNING)`);
  program.push(`(MACHINE: ${machine.brand} ${machine.model} ${year} - ${machine.control})`);
  if (params.shopMachineName) program.push(`(SHOP MACHINE RECORD: ${params.shopMachineName})`);
  program.push(`(OPERATION: ${operation.label})`);
  program.push(`(STOCK: X${g(stockX)} Y${g(stockY)} Z${g(stockZ)})`);
  if (params.lineage) program.push(`(IMPORTED DATA: ${String(params.lineage).slice(0, 180)})`);
  if (machine.type === "lathe") {
    buildLatheGCode({ program, params, machine, stockX, stockZ, depth, safeZ, rpm, feed });
  } else {
    buildMillGCode({ program, params, machine, stockX, stockY, depth, safeZ, toolDiameter, rpm, feed });
  }

  return {
    machine,
    operation,
    program: program.join("\n"),
    warnings: [
      "This is a starter template, not a certified post-processed program.",
      "Verify work offset, tool length offset, units, clearance planes, fixturing, toolpath, and control-specific syntax before running.",
    ],
    confidence: "Medium",
  };
};

//////////////////////////////////////////////////
// UNIT CONVERSION
//////////////////////////////////////////////////

export const UNIT_OPTIONS = {
  length: [
    { value: "mm", label: "Millimeters (mm)" },
    { value: "cm", label: "Centimeters (cm)" },
    { value: "m", label: "Meters (m)" },
    { value: "in", label: "Inches (in)" },
    { value: "ft", label: "Feet (ft)" },
    { value: "yd", label: "Yards (yd)" },
    { value: "mi", label: "Miles (mi)" },
  ],
  weight: [
    { value: "mg", label: "Milligrams (mg)" },
    { value: "g", label: "Grams (g)" },
    { value: "kg", label: "Kilograms (kg)" },
    { value: "oz", label: "Ounces (oz)" },
    { value: "lb", label: "Pounds (lb)" },
    { value: "ton_us", label: "US Tons (ton)" },
  ],
  volume: [
    { value: "ml", label: "Milliliters (mL)" },
    { value: "l", label: "Liters (L)" },
    { value: "in3", label: "Cubic Inches (in³)" },
    { value: "ft3", label: "Cubic Feet (ft³)" },
    { value: "gal_us", label: "US Gallons (gal)" },
    { value: "qt_us", label: "US Quarts (qt)" },
    { value: "pt_us", label: "US Pints (pt)" },
    { value: "fl_oz_us", label: "US Fluid Ounces (fl oz)" },
  ],
  speed: [
    { value: "mm_per_min", label: "Millimeters / min (mm/min)" },
    { value: "mm_per_sec", label: "Millimeters / sec (mm/sec)" },
    { value: "m_per_min", label: "Meters / min (m/min)" },
    { value: "m_per_sec", label: "Meters / sec (m/sec)" },
    { value: "in_per_min", label: "Inches / min (in/min)" },
    { value: "in_per_sec", label: "Inches / sec (in/sec)" },
    { value: "ft_per_min", label: "Feet / min (ft/min)" },
    { value: "ft_per_sec", label: "Feet / sec (ft/sec)" },
    { value: "mph", label: "Miles per Hour (mph)" },
  ],
  pressure: [
    { value: "psi", label: "PSI" },
    { value: "ksi", label: "KSI" },
    { value: "bar", label: "Bar" },
    { value: "kpa", label: "Kilopascals (kPa)" },
    { value: "mpa", label: "Megapascals (MPa)" },
  ],
  temperature: [
    { value: "f", label: "Fahrenheit (°F)" },
    { value: "c", label: "Celsius (°C)" },
    { value: "k", label: "Kelvin (K)" },
  ],
};

const UNIT_CATEGORIES = {
  length: {
    mm: 1,
    cm: 10,
    m: 1000,
    in: 25.4,
    ft: 304.8,
    yd: 914.4,
    mi: 1609344,
  },
  weight: {
    mg: 0.001,
    g: 1,
    kg: 1000,
    oz: 28.3495,
    lb: 453.592,
    ton_us: 907184.74,
  },
  volume: {
    ml: 1,
    l: 1000,
    in3: 16.387064,
    ft3: 28316.846592,
    gal_us: 3785.411784,
    qt_us: 946.352946,
    pt_us: 473.176473,
    fl_oz_us: 29.57353,
  },
  speed: {
    mm_per_min: 0.001,
    mm_per_sec: 0.06,
    m_per_min: 1,
    m_per_sec: 60,
    in_per_min: 0.0254,
    in_per_sec: 1.524,
    ft_per_min: 0.3048,
    ft_per_sec: 18.288,
    mph: 26.8224,
  },
  pressure: {
    psi: 1,
    ksi: 1000,
    bar: 14.5038,
    kpa: 0.145038,
    mpa: 145.038,
  },
};

const findUnitCategory = (unit) => {
  if (["f", "c", "k"].includes(unit)) return "temperature";

  for (const category in UNIT_CATEGORIES) {
    if (UNIT_CATEGORIES[category][unit] !== undefined) {
      return category;
    }
  }

  return null;
};

const convertTemperature = (value, fromUnit, toUnit) => {
  let celsiusValue;

  switch (fromUnit) {
    case "f":
      celsiusValue = ((value - 32) * 5) / 9;
      break;
    case "k":
      celsiusValue = value - 273.15;
      break;
    case "c":
    default:
      celsiusValue = value;
      break;
  }

  switch (toUnit) {
    case "f":
      return (celsiusValue * 9) / 5 + 32;
    case "k":
      return celsiusValue + 273.15;
    case "c":
    default:
      return celsiusValue;
  }
};

export const convertUnits = (params) => {
  const errors = validateInputs(params, ["value", "fromUnit", "toUnit"]);
  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const { value, fromUnit, toUnit } = params;

  const fromCategory = findUnitCategory(fromUnit);
  const toCategory = findUnitCategory(toUnit);

  if (!fromCategory || !toCategory) {
    return {
      errors: { fromUnit: "Invalid unit selection" },
      warnings: [],
      confidence: "Invalid",
    };
  }

  if (fromCategory !== toCategory) {
    return {
      errors: { toUnit: "Cannot convert between different unit types" },
      warnings: [],
      confidence: "Invalid",
    };
  }

  if (fromUnit === toUnit) {
    return {
      result: Math.round(Number(value) * 10000) / 10000,
      warnings: [],
      confidence: "High",
    };
  }

  let result;

  if (fromCategory === "temperature") {
    result = convertTemperature(Number(value), fromUnit, toUnit);
  } else {
    const baseValue = Number(value) * UNIT_CATEGORIES[fromCategory][fromUnit];
    result = baseValue / UNIT_CATEGORIES[toCategory][toUnit];
  }

  return {
    result: Math.round(result * 10000) / 10000,
    warnings: [],
    confidence: "High",
  };
};

//////////////////////////////////////////////////
// TRIG
//////////////////////////////////////////////////

const degToRad = (deg) => (deg * Math.PI) / 180;
const radToDeg = (rad) => (rad * 180) / Math.PI;
const isPositive = (value) =>
  typeof value === "number" && !Number.isNaN(value) && value > 0;
const isAcuteAngle = (value) =>
  typeof value === "number" && !Number.isNaN(value) && value > 0 && value < 90;
const roundTrig = (value) => Math.round(value * 10000) / 10000;

export const calculateTrig = (params) => {
  const warnings = [];

  let a = Number(params.a);
  let b = Number(params.b);
  let c = Number(params.c);
  let angleB = Number(params.angleB);
  let angleC = Number(params.angleC);

  a = isPositive(a) ? a : null;
  b = isPositive(b) ? b : null;
  c = isPositive(c) ? c : null;
  angleB = isAcuteAngle(angleB) ? angleB : null;
  angleC = isAcuteAngle(angleC) ? angleC : null;

  const sideCount = [a, b, c].filter((v) => v !== null).length;
  const angleCount = [angleB, angleC].filter((v) => v !== null).length;
  const totalKnown = sideCount + angleCount;

  if (totalKnown < 2) {
    return {
      errors: {
        inputs: "Enter at least 2 valid pieces of information to solve the right triangle.",
      },
      warnings,
      confidence: "Invalid",
    };
  }

  if (angleB !== null && angleC !== null) {
    if (Math.abs(angleB + angleC - 90) > 0.05) {
      return {
        errors: {
          angles: "In a right triangle, angle B + angle C must equal 90°.",
        },
        warnings,
        confidence: "Invalid",
      };
    }
  }

  if (angleB !== null && angleC === null) {
    angleC = 90 - angleB;
  } else if (angleC !== null && angleB === null) {
    angleB = 90 - angleC;
  }

  try {
    // Three sides
    if (a !== null && b !== null && c !== null) {
      const largest = Math.max(a, b, c);
      if (largest !== a) {
        return {
          errors: {
            sides: "For this right triangle solver, side a must be the hypotenuse when all 3 sides are entered.",
          },
          warnings,
          confidence: "Invalid",
        };
      }

      if (Math.abs(a * a - (b * b + c * c)) > 0.05) {
        return {
          errors: {
            sides: "The entered sides do not satisfy the Pythagorean theorem for a right triangle.",
          },
          warnings,
          confidence: "Invalid",
        };
      }

      angleB = radToDeg(Math.asin(b / a));
      angleC = 90 - angleB;
    }
    // Hypotenuse + leg
    else if (a !== null && b !== null) {
      if (a <= b) {
        return {
          errors: {
            sides: "Hypotenuse a must be longer than leg b.",
          },
          warnings,
          confidence: "Invalid",
        };
      }
      c = Math.sqrt(a * a - b * b);
      angleB = radToDeg(Math.asin(b / a));
      angleC = 90 - angleB;
    } else if (a !== null && c !== null) {
      if (a <= c) {
        return {
          errors: {
            sides: "Hypotenuse a must be longer than leg c.",
          },
          warnings,
          confidence: "Invalid",
        };
      }
      b = Math.sqrt(a * a - c * c);
      angleC = radToDeg(Math.asin(c / a));
      angleB = 90 - angleC;
    }
    // Two legs
    else if (b !== null && c !== null) {
      a = Math.sqrt(b * b + c * c);
      angleB = radToDeg(Math.atan(b / c));
      angleC = 90 - angleB;
    }
    // Hypotenuse + acute angle
    else if (a !== null && angleB !== null) {
      b = a * Math.sin(degToRad(angleB));
      c = a * Math.cos(degToRad(angleB));
      angleC = 90 - angleB;
    } else if (a !== null && angleC !== null) {
      c = a * Math.sin(degToRad(angleC));
      b = a * Math.cos(degToRad(angleC));
      angleB = 90 - angleC;
    }
    // Leg b + angle
    else if (b !== null && angleB !== null) {
      a = b / Math.sin(degToRad(angleB));
      c = b / Math.tan(degToRad(angleB));
      angleC = 90 - angleB;
    } else if (b !== null && angleC !== null) {
      angleB = 90 - angleC;
      a = b / Math.sin(degToRad(angleB));
      c = b / Math.tan(degToRad(angleB));
    }
    // Leg c + angle
    else if (c !== null && angleC !== null) {
      a = c / Math.sin(degToRad(angleC));
      b = c / Math.tan(degToRad(angleC));
      angleB = 90 - angleC;
    } else if (c !== null && angleB !== null) {
      angleC = 90 - angleB;
      a = c / Math.sin(degToRad(angleC));
      b = c / Math.tan(degToRad(angleC));
    } else {
      return {
        errors: {
          inputs: "Enter a valid right-triangle combination such as a+b, a+c, b+c, a+angle, b+angle, or c+angle.",
        },
        warnings,
        confidence: "Invalid",
      };
    }
  } catch {
    return {
      errors: {
        inputs: "Unable to solve the right triangle from the provided values.",
      },
      warnings,
      confidence: "Invalid",
    };
  }

  if (
    !isPositive(a) ||
    !isPositive(b) ||
    !isPositive(c) ||
    !isAcuteAngle(angleB) ||
    !isAcuteAngle(angleC)
  ) {
    return {
      errors: {
        inputs: "The provided values do not produce a valid right triangle.",
      },
      warnings,
      confidence: "Invalid",
    };
  }

  if (Math.abs(angleB + angleC - 90) > 0.05) {
    return {
      errors: {
        angles: "Solved angles B and C do not add up to 90°.",
      },
      warnings,
      confidence: "Invalid",
    };
  }

  if (Math.abs(a * a - (b * b + c * c)) > 0.1) {
    return {
      errors: {
        sides: "Solved sides do not satisfy the Pythagorean theorem.",
      },
      warnings,
      confidence: "Invalid",
    };
  }

  const area = 0.5 * b * c;
  const perimeter = a + b + c;

  return {
    a: roundTrig(a),
    b: roundTrig(b),
    c: roundTrig(c),
    angleA: 90,
    angleB: roundTrig(angleB),
    angleC: roundTrig(angleC),
    area: roundTrig(area),
    perimeter: roundTrig(perimeter),
    warnings,
    confidence: warnings.length === 0 ? "High" : "Medium",
  };
};

//////////////////////////////////////////////////
// BOLT PATTERN
//////////////////////////////////////////////////

export const calculateBoltPattern = (params) => {
  const errors = validateInputs(params, ["boltCount", "patternDiameter"]);
  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const { boltCount, patternDiameter } = params;

  if (boltCount < 3) errors.boltCount = "Bolt count must be at least 3";
  if (patternDiameter <= 0) errors.patternDiameter = "Pattern diameter must be positive";

  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const angleStep = (2 * Math.PI) / boltCount;
  const coordinates = [];

  for (let i = 0; i < boltCount; i++) {
    const angle = i * angleStep;
    const x = (patternDiameter / 2) * Math.cos(angle);
    const y = (patternDiameter / 2) * Math.sin(angle);
    coordinates.push({
      x: Math.round(x * 1000) / 1000,
      y: Math.round(y * 1000) / 1000,
    });
  }

  return {
    coordinates,
    warnings: [],
    confidence: "High",
  };
};

//////////////////////////////////////////////////
// SHOP MATH
//////////////////////////////////////////////////

export const calculateShopMath = (params) => {
  const errors = validateInputs(params, ["operation", "value1", "value2"]);
  if (Object.keys(errors).length > 0) return { errors, confidence: "Invalid" };

  const { operation, value1, value2 } = params;

  let result = 0;
  const warnings = [];

  switch (operation) {
    case "add":
      result = value1 + value2;
      break;
    case "subtract":
      result = value1 - value2;
      break;
    case "multiply":
      result = value1 * value2;
      break;
    case "divide":
      if (value2 === 0) {
        errors.value2 = "Division by zero";
        return { errors, confidence: "Invalid" };
      }
      result = value1 / value2;
      break;
    default:
      errors.operation = "Invalid operation";
      return { errors, confidence: "Invalid" };
  }

  return {
    result: Math.round(result * 10000) / 10000,
    warnings,
    confidence: "High",
  };
};

//////////////////////////////////////////////////
// SAVE CALCULATION
//////////////////////////////////////////////////

export const saveCalculation = (toolId, params, results) => {
  const calculationData = {
    id: Date.now().toString(),
    toolId,
    params,
    results,
    timestamp: new Date().toISOString(),
  };

  console.log("Saving calculation:", calculationData);

  const saved = JSON.parse(localStorage.getItem("manucalc_calculations") || "[]");
  saved.push(calculationData);
  localStorage.setItem("manucalc_calculations", JSON.stringify(saved));

  return calculationData.id;
};
